import type { SwellData, SwellSettingsGeo } from 'types/swell';

export const FILE_DATA_INCLUDE_QUERY: SwellData = {
  url: '/:themes:configs/{id}/file/data',
  conditions: {
    // Only expand theme files
    // Do not expand non-text data
    file: {
      $or: [
        {
          $and: [
            { content_type: { $regex: '^(?!image)' } },
            { content_type: { $regex: '^(?!video)' } },
          ],
        },
        { content_type: { $regex: '^image/svg' } },
      ],
    },
    // Do not return assets unless they end with .liquid.[ext] or css/js/svg
    $or: [
      { file_path: { $regex: '^(?!theme/assets/)' } },
      { file_path: { $regex: '.liquid.[a-zA-Z0-9]+$' } },
      { file_path: { $regex: '.(css|js|svg)$' } },
    ],
  },
};

export const GEO_DATA: SwellSettingsGeo = {
  countries: [
    {
      id: 'US',
      name: 'United States',
      state_label: 'State',
    },
    {
      id: 'CA',
      name: 'Canada',
      state_label: 'Province',
    },
    {
      id: 'AU',
      name: 'Australia',
      state_label: 'State/territory',
    },
    {
      id: 'GB',
      name: 'United Kingdom',
    },
    {
      id: 'AF',
      name: 'Afghanistan',
    },
    {
      id: 'AX',
      name: 'Aland Islands',
    },
    {
      id: 'AL',
      name: 'Albania',
    },
    {
      id: 'DZ',
      name: 'Algeria',
      state_label: 'Province',
    },
    {
      id: 'AD',
      name: 'Andorra',
    },
    {
      id: 'AO',
      name: 'Angola',
    },
    {
      id: 'AI',
      name: 'Anguilla',
    },
    {
      id: 'AG',
      name: 'Antigua And Barbuda',
    },
    {
      id: 'AR',
      name: 'Argentina',
    },
    {
      id: 'AM',
      name: 'Armenia',
    },
    {
      id: 'AW',
      name: 'Aruba',
    },
    {
      id: 'AT',
      name: 'Austria',
    },
    {
      id: 'AZ',
      name: 'Azerbaijan',
    },
    {
      id: 'BS',
      name: 'Bahamas',
    },
    {
      id: 'BH',
      name: 'Bahrain',
    },
    {
      id: 'BD',
      name: 'Bangladesh',
    },
    {
      id: 'BB',
      name: 'Barbados',
    },
    {
      id: 'BY',
      name: 'Belarus',
    },
    {
      id: 'BE',
      name: 'Belgium',
    },
    {
      id: 'BZ',
      name: 'Belize',
    },
    {
      id: 'BJ',
      name: 'Benin',
    },
    {
      id: 'BM',
      name: 'Bermuda',
    },
    {
      id: 'BT',
      name: 'Bhutan',
    },
    {
      id: 'BO',
      name: 'Bolivia',
    },
    {
      id: 'BA',
      name: 'Bosnia And Herzegovina',
    },
    {
      id: 'BW',
      name: 'Botswana',
    },
    {
      id: 'BV',
      name: 'Bouvet Island',
    },
    {
      id: 'BR',
      name: 'Brazil',
      state_label: 'State',
    },
    {
      id: 'IO',
      name: 'British Indian Ocean Territory',
    },
    {
      id: 'BN',
      name: 'Brunei',
    },
    {
      id: 'BG',
      name: 'Bulgaria',
    },
    {
      id: 'BF',
      name: 'Burkina Faso',
    },
    {
      id: 'BU',
      name: 'Burma',
    },
    {
      id: 'BI',
      name: 'Burundi',
    },
    {
      id: 'KH',
      name: 'Cambodia',
    },
    {
      id: 'CM',
      name: 'Cameroon',
    },
    {
      id: 'CV',
      name: 'Cape Verde',
    },
    {
      id: 'KY',
      name: 'Cayman Islands',
    },
    {
      id: 'CF',
      name: 'Central African Republic',
    },
    {
      id: 'TD',
      name: 'Chad',
    },
    {
      id: 'CL',
      name: 'Chile',
    },
    {
      id: 'CN',
      name: 'China',
    },
    {
      id: 'CX',
      name: 'Christmas Island',
    },
    {
      id: 'CC',
      name: 'Cocos (Keeling) Islands',
    },
    {
      id: 'CO',
      name: 'Colombia',
    },
    {
      id: 'KM',
      name: 'Comoros',
    },
    {
      id: 'CG',
      name: 'Congo',
    },
    {
      id: 'CD',
      name: 'Congo, The Democratic Republic Of The',
    },
    {
      id: 'CK',
      name: 'Cook Islands',
    },
    {
      id: 'CR',
      name: 'Costa Rica',
    },
    {
      id: 'CI',
      name: "Cote D'Ivoire",
    },
    {
      id: 'HR',
      name: 'Croatia',
    },
    {
      id: 'CU',
      name: 'Cuba',
    },
    {
      id: 'CY',
      name: 'Cyprus',
    },
    {
      id: 'CZ',
      name: 'Czech Republic',
    },
    {
      id: 'DK',
      name: 'Denmark',
    },
    {
      id: 'DJ',
      name: 'Djibouti',
    },
    {
      id: 'DM',
      name: 'Dominica',
    },
    {
      id: 'DO',
      name: 'Dominican Republic',
    },
    {
      id: 'EC',
      name: 'Ecuador',
    },
    {
      id: 'EG',
      name: 'Egypt',
    },
    {
      id: 'SV',
      name: 'El Salvador',
    },
    {
      id: 'GQ',
      name: 'Equatorial Guinea',
    },
    {
      id: 'ER',
      name: 'Eritrea',
    },
    {
      id: 'EE',
      name: 'Estonia',
    },
    {
      id: 'ET',
      name: 'Ethiopia',
    },
    {
      id: 'FK',
      name: 'Falkland Islands (Malvinas)',
    },
    {
      id: 'FO',
      name: 'Faroe Islands',
    },
    {
      id: 'FJ',
      name: 'Fiji',
    },
    {
      id: 'FI',
      name: 'Finland',
    },
    {
      id: 'FR',
      name: 'France',
    },
    {
      id: 'GF',
      name: 'French Guiana',
    },
    {
      id: 'PF',
      name: 'French Polynesia',
    },
    {
      id: 'TF',
      name: 'French Southern Territories',
    },
    {
      id: 'GA',
      name: 'Gabon',
    },
    {
      id: 'GM',
      name: 'Gambia',
    },
    {
      id: 'GE',
      name: 'Georgia',
    },
    {
      id: 'DE',
      name: 'Germany',
    },
    {
      id: 'GH',
      name: 'Ghana',
    },
    {
      id: 'GI',
      name: 'Gibraltar',
    },
    {
      id: 'GR',
      name: 'Greece',
    },
    {
      id: 'GL',
      name: 'Greenland',
    },
    {
      id: 'GD',
      name: 'Grenada',
    },
    {
      id: 'GP',
      name: 'Guadeloupe',
    },
    {
      id: 'GT',
      name: 'Guatemala',
      state_label: 'Department',
    },
    {
      id: 'GG',
      name: 'Guernsey',
    },
    {
      id: 'GN',
      name: 'Guinea',
    },
    {
      id: 'GW',
      name: 'Guinea Bissau',
    },
    {
      id: 'GY',
      name: 'Guyana',
    },
    {
      id: 'HT',
      name: 'Haiti',
    },
    {
      id: 'HM',
      name: 'Heard Island And Mcdonald Islands',
    },
    {
      id: 'VA',
      name: 'Holy See (Vatican City State)',
    },
    {
      id: 'HN',
      name: 'Honduras',
    },
    {
      id: 'HK',
      name: 'Hong Kong',
    },
    {
      id: 'HU',
      name: 'Hungary',
    },
    {
      id: 'IS',
      name: 'Iceland',
    },
    {
      id: 'IN',
      name: 'India',
      state_label: 'State',
    },
    {
      id: 'ID',
      name: 'Indonesia',
    },
    {
      id: 'IR',
      name: 'Iran, Islamic Republic Of',
    },
    {
      id: 'IQ',
      name: 'Iraq',
    },
    {
      id: 'IE',
      name: 'Ireland',
    },
    {
      id: 'IM',
      name: 'Isle Of Man',
    },
    {
      id: 'IL',
      name: 'Israel',
    },
    {
      id: 'IT',
      name: 'Italy',
    },
    {
      id: 'JM',
      name: 'Jamaica',
    },
    {
      id: 'JP',
      name: 'Japan',
    },
    {
      id: 'JE',
      name: 'Jersey',
    },
    {
      id: 'JO',
      name: 'Jordan',
    },
    {
      id: 'KZ',
      name: 'Kazakhstan',
    },
    {
      id: 'KE',
      name: 'Kenya',
    },
    {
      id: 'KI',
      name: 'Kiribati',
    },
    {
      id: 'KP',
      name: 'Korea, North',
    },
    {
      id: 'KR',
      name: 'Korea, South',
    },
    {
      id: 'KW',
      name: 'Kuwait',
    },
    {
      id: 'KG',
      name: 'Kyrgyzstan',
    },
    {
      id: 'LA',
      name: 'Laos',
    },
    {
      id: 'LV',
      name: 'Latvia',
    },
    {
      id: 'LB',
      name: 'Lebanon',
    },
    {
      id: 'LS',
      name: 'Lesotho',
    },
    {
      id: 'LR',
      name: 'Liberia',
    },
    {
      id: 'LY',
      name: 'Libya',
    },
    {
      id: 'LI',
      name: 'Liechtenstein',
    },
    {
      id: 'LT',
      name: 'Lithuania',
    },
    {
      id: 'LU',
      name: 'Luxembourg',
    },
    {
      id: 'MO',
      name: 'Macao',
    },
    {
      id: 'MK',
      name: 'Macedonia',
    },
    {
      id: 'MG',
      name: 'Madagascar',
    },
    {
      id: 'MW',
      name: 'Malawi',
    },
    {
      id: 'MY',
      name: 'Malaysia',
      state_label: 'State/territory',
    },
    {
      id: 'MV',
      name: 'Maldives',
    },
    {
      id: 'ML',
      name: 'Mali',
    },
    {
      id: 'MT',
      name: 'Malta',
    },
    {
      id: 'MQ',
      name: 'Martinique',
    },
    {
      id: 'MR',
      name: 'Mauritania',
    },
    {
      id: 'MU',
      name: 'Mauritius',
    },
    {
      id: 'YT',
      name: 'Mayotte',
    },
    {
      id: 'MX',
      name: 'Mexico',
      state_label: 'State',
    },
    {
      id: 'MD',
      name: 'Moldova',
    },
    {
      id: 'MC',
      name: 'Monaco',
    },
    {
      id: 'MN',
      name: 'Mongolia',
    },
    {
      id: 'ME',
      name: 'Montenegro',
    },
    {
      id: 'MS',
      name: 'Montserrat',
    },
    {
      id: 'MA',
      name: 'Morocco',
    },
    {
      id: 'MZ',
      name: 'Mozambique',
    },
    {
      id: 'MM',
      name: 'Myanmar',
    },
    {
      id: 'NA',
      name: 'Namibia',
    },
    {
      id: 'NR',
      name: 'Nauru',
    },
    {
      id: 'NP',
      name: 'Nepal',
    },
    {
      id: 'NL',
      name: 'Netherlands',
    },
    {
      id: 'AN',
      name: 'Netherlands Antilles',
    },
    {
      id: 'NC',
      name: 'New Caledonia',
    },
    {
      id: 'NZ',
      name: 'New Zealand',
      state_label: 'Region',
    },
    {
      id: 'NI',
      name: 'Nicaragua',
    },
    {
      id: 'NE',
      name: 'Niger',
    },
    {
      id: 'NG',
      name: 'Nigeria',
    },
    {
      id: 'NU',
      name: 'Niue',
    },
    {
      id: 'NF',
      name: 'Norfolk Island',
    },
    {
      id: 'NO',
      name: 'Norway',
    },
    {
      id: 'OM',
      name: 'Oman',
    },
    {
      id: 'PK',
      name: 'Pakistan',
    },
    {
      id: 'PS',
      name: 'Palestinian Territory, Occupied',
    },
    {
      id: 'PA',
      name: 'Panama',
    },
    {
      id: 'PG',
      name: 'Papua New Guinea',
    },
    {
      id: 'PY',
      name: 'Paraguay',
    },
    {
      id: 'PE',
      name: 'Peru',
    },
    {
      id: 'PH',
      name: 'Philippines',
      state_label: 'Region',
    },
    {
      id: 'PN',
      name: 'Pitcairn',
    },
    {
      id: 'PL',
      name: 'Poland',
    },
    {
      id: 'PT',
      name: 'Portugal',
    },
    {
      id: 'QA',
      name: 'Qatar',
    },
    {
      id: 'RE',
      name: 'Reunion',
    },
    {
      id: 'RO',
      name: 'Romania',
    },
    {
      id: 'RU',
      name: 'Russia',
    },
    {
      id: 'RW',
      name: 'Rwanda',
    },
    {
      id: 'BL',
      name: 'Saint Barthelemy',
    },
    {
      id: 'SH',
      name: 'Saint Helena',
    },
    {
      id: 'KN',
      name: 'Saint Kitts And Nevis',
    },
    {
      id: 'LC',
      name: 'Saint Lucia',
    },
    {
      id: 'MF',
      name: 'Saint Martin',
    },
    {
      id: 'PM',
      name: 'Saint Pierre And Miquelon',
    },
    {
      id: 'VC',
      name: 'Saint Vincent',
    },
    {
      id: 'WS',
      name: 'Samoa',
    },
    {
      id: 'SM',
      name: 'San Marino',
    },
    {
      id: 'ST',
      name: 'Sao Tome And Principe',
    },
    {
      id: 'SA',
      name: 'Saudi Arabia',
    },
    {
      id: 'SN',
      name: 'Senegal',
    },
    {
      id: 'RS',
      name: 'Serbia',
    },
    {
      id: 'SC',
      name: 'Seychelles',
    },
    {
      id: 'SL',
      name: 'Sierra Leone',
    },
    {
      id: 'SG',
      name: 'Singapore',
    },
    {
      id: 'SK',
      name: 'Slovakia',
    },
    {
      id: 'SI',
      name: 'Slovenia',
    },
    {
      id: 'SB',
      name: 'Solomon Islands',
    },
    {
      id: 'SO',
      name: 'Somalia',
    },
    {
      id: 'ZA',
      name: 'South Africa',
    },
    {
      id: 'GS',
      name: 'South Georgia And The South Sandwich Islands',
    },
    {
      id: 'ES',
      name: 'Spain',
      state_label: 'Province',
    },
    {
      id: 'LK',
      name: 'Sri Lanka',
    },
    {
      id: 'SD',
      name: 'Sudan',
    },
    {
      id: 'SR',
      name: 'Suriname',
    },
    {
      id: 'SJ',
      name: 'Svalbard And Jan Mayen',
    },
    {
      id: 'SZ',
      name: 'Swaziland',
    },
    {
      id: 'SE',
      name: 'Sweden',
    },
    {
      id: 'CH',
      name: 'Switzerland',
    },
    {
      id: 'SY',
      name: 'Syria',
    },
    {
      id: 'TW',
      name: 'Taiwan',
    },
    {
      id: 'TJ',
      name: 'Tajikistan',
    },
    {
      id: 'TZ',
      name: 'Tanzania',
    },
    {
      id: 'TH',
      name: 'Thailand',
    },
    {
      id: 'TL',
      name: 'Timor-Leste',
    },
    {
      id: 'TG',
      name: 'Togo',
    },
    {
      id: 'TK',
      name: 'Tokelau',
    },
    {
      id: 'TO',
      name: 'Tonga',
    },
    {
      id: 'TT',
      name: 'Trinidad and Tobago',
    },
    {
      id: 'TN',
      name: 'Tunisia',
    },
    {
      id: 'TR',
      name: 'Turkey',
    },
    {
      id: 'TM',
      name: 'Turkmenistan',
    },
    {
      id: 'TC',
      name: 'Turks And Caicos Islands',
    },
    {
      id: 'TV',
      name: 'Tuvalu',
    },
    {
      id: 'UG',
      name: 'Uganda',
    },
    {
      id: 'UA',
      name: 'Ukraine',
    },
    {
      id: 'AE',
      name: 'United Arab Emirates',
      state_label: 'Emirate',
    },
    {
      id: 'UM',
      name: 'United States Minor Outlying Islands',
    },
    {
      id: 'UY',
      name: 'Uruguay',
    },
    {
      id: 'UZ',
      name: 'Uzbekistan',
    },
    {
      id: 'VU',
      name: 'Vanuatu',
    },
    {
      id: 'VE',
      name: 'Venezuela',
    },
    {
      id: 'VN',
      name: 'Vietnam',
    },
    {
      id: 'VG',
      name: 'Virgin Islands, British',
    },
    {
      id: 'WF',
      name: 'Wallis And Futuna',
    },
    {
      id: 'EH',
      name: 'Western Sahara',
    },
    {
      id: 'YE',
      name: 'Yemen',
    },
    {
      id: 'ZM',
      name: 'Zambia',
    },
    {
      id: 'ZW',
      name: 'Zimbabwe',
    },
  ],
  states: [
    {
      country: 'US',
      id: 'AL',
      name: 'Alabama',
    },
    {
      country: 'US',
      id: 'AK',
      name: 'Alaska',
    },
    {
      country: 'US',
      id: 'AZ',
      name: 'Arizona',
    },
    {
      country: 'US',
      id: 'AR',
      name: 'Arkansas',
    },
    {
      country: 'US',
      id: 'CA',
      name: 'California',
    },
    {
      country: 'US',
      id: 'CO',
      name: 'Colorado',
    },
    {
      country: 'US',
      id: 'CT',
      name: 'Connecticut',
    },
    {
      country: 'US',
      id: 'DE',
      name: 'Delaware',
    },
    {
      country: 'US',
      id: 'DC',
      name: 'District of Columbia',
    },
    {
      country: 'US',
      id: 'FL',
      name: 'Florida',
    },
    {
      country: 'US',
      id: 'GA',
      name: 'Georgia',
    },
    {
      country: 'US',
      id: 'HI',
      name: 'Hawaii',
    },
    {
      country: 'US',
      id: 'ID',
      name: 'Idaho',
    },
    {
      country: 'US',
      id: 'IL',
      name: 'Illinois',
    },
    {
      country: 'US',
      id: 'IN',
      name: 'Indiana',
    },
    {
      country: 'US',
      id: 'IA',
      name: 'Iowa',
    },
    {
      country: 'US',
      id: 'KS',
      name: 'Kansas',
    },
    {
      country: 'US',
      id: 'KY',
      name: 'Kentucky',
    },
    {
      country: 'US',
      id: 'LA',
      name: 'Louisiana',
    },
    {
      country: 'US',
      id: 'ME',
      name: 'Maine',
    },
    {
      country: 'US',
      id: 'MD',
      name: 'Maryland',
    },
    {
      country: 'US',
      id: 'MA',
      name: 'Massachusetts',
    },
    {
      country: 'US',
      id: 'MI',
      name: 'Michigan',
    },
    {
      country: 'US',
      id: 'MN',
      name: 'Minnesota',
    },
    {
      country: 'US',
      id: 'MS',
      name: 'Mississippi',
    },
    {
      country: 'US',
      id: 'MO',
      name: 'Missouri',
    },
    {
      country: 'US',
      id: 'MT',
      name: 'Montana',
    },
    {
      country: 'US',
      id: 'NE',
      name: 'Nebraska',
    },
    {
      country: 'US',
      id: 'NV',
      name: 'Nevada',
    },
    {
      country: 'US',
      id: 'NH',
      name: 'New Hampshire',
    },
    {
      country: 'US',
      id: 'NJ',
      name: 'New Jersey',
    },
    {
      country: 'US',
      id: 'NM',
      name: 'New Mexico',
    },
    {
      country: 'US',
      id: 'NY',
      name: 'New York',
    },
    {
      country: 'US',
      id: 'NC',
      name: 'North Carolina',
    },
    {
      country: 'US',
      id: 'ND',
      name: 'North Dakota',
    },
    {
      country: 'US',
      id: 'OH',
      name: 'Ohio',
    },
    {
      country: 'US',
      id: 'OK',
      name: 'Oklahoma',
    },
    {
      country: 'US',
      id: 'OR',
      name: 'Oregon',
    },
    {
      country: 'US',
      id: 'PA',
      name: 'Pennsylvania',
    },
    {
      country: 'US',
      id: 'RI',
      name: 'Rhode Island',
    },
    {
      country: 'US',
      id: 'SC',
      name: 'South Carolina',
    },
    {
      country: 'US',
      id: 'SD',
      name: 'South Dakota',
    },
    {
      country: 'US',
      id: 'TN',
      name: 'Tennessee',
    },
    {
      country: 'US',
      id: 'TX',
      name: 'Texas',
    },
    {
      country: 'US',
      id: 'UT',
      name: 'Utah',
    },
    {
      country: 'US',
      id: 'VT',
      name: 'Vermont',
    },
    {
      country: 'US',
      id: 'VA',
      name: 'Virginia',
    },
    {
      country: 'US',
      id: 'WA',
      name: 'Washington',
    },
    {
      country: 'US',
      id: 'WV',
      name: 'West Virginia',
    },
    {
      country: 'US',
      id: 'WI',
      name: 'Wisconsin',
    },
    {
      country: 'US',
      id: 'WY',
      name: 'Wyoming',
    },
    {
      country: 'US',
      id: 'AS',
      name: 'American Samoa',
    },
    {
      country: 'US',
      id: 'AA',
      name: 'Armed Forces Americas',
    },
    {
      country: 'US',
      id: 'AE',
      name: 'Armed Forces Europe',
    },
    {
      country: 'US',
      id: 'AP',
      name: 'Armed Forces Pacific',
    },
    {
      country: 'US',
      id: 'FM',
      name: 'Federated States of Micronesia',
    },
    {
      country: 'US',
      id: 'GU',
      name: 'Guam',
    },
    {
      country: 'US',
      id: 'MH',
      name: 'Marshall Islands',
    },
    {
      country: 'US',
      id: 'MP',
      name: 'Northern Mariana Islands',
    },
    {
      country: 'US',
      id: 'PW',
      name: 'Palau',
    },
    {
      country: 'US',
      id: 'PR',
      name: 'Puerto Rico',
    },
    {
      country: 'US',
      id: 'VI',
      name: 'Virgin Islands',
    },
    {
      country: 'CA',
      id: 'AB',
      name: 'Alberta',
    },
    {
      country: 'CA',
      id: 'BC',
      name: 'British Columbia',
    },
    {
      country: 'CA',
      id: 'MB',
      name: 'Manitoba',
    },
    {
      country: 'CA',
      id: 'NB',
      name: 'New Brunswick',
    },
    {
      country: 'CA',
      id: 'NL',
      name: 'Newfoundland',
    },
    {
      country: 'CA',
      id: 'NT',
      name: 'Northwest Territories',
    },
    {
      country: 'CA',
      id: 'NS',
      name: 'Nova Scotia',
    },
    {
      country: 'CA',
      id: 'NU',
      name: 'Nunavut',
    },
    {
      country: 'CA',
      id: 'ON',
      name: 'Ontario',
    },
    {
      country: 'CA',
      id: 'PE',
      name: 'Prince Edward Island',
    },
    {
      country: 'CA',
      id: 'QC',
      name: 'Quebec',
    },
    {
      country: 'CA',
      id: 'SK',
      name: 'Saskatchewan',
    },
    {
      country: 'CA',
      id: 'YT',
      name: 'Yukon',
    },
    {
      country: 'AU',
      id: 'ACT',
      name: 'Australian Capital Territory',
    },
    {
      country: 'AU',
      id: 'NSW',
      name: 'New South Wales',
    },
    {
      country: 'AU',
      id: 'NT',
      name: 'Northern Territory',
    },
    {
      country: 'AU',
      id: 'QLD',
      name: 'Queensland',
    },
    {
      country: 'AU',
      id: 'SA',
      name: 'South Australia',
    },
    {
      country: 'AU',
      id: 'TAS',
      name: 'Tasmania',
    },
    {
      country: 'AU',
      id: 'VIC',
      name: 'Victoria',
    },
    {
      country: 'AU',
      id: 'WA',
      name: 'Western Australia',
    },
    {
      country: 'BR',
      id: 'AC',
      name: 'Acre',
    },
    {
      country: 'BR',
      id: 'AL',
      name: 'Alagoas',
    },
    {
      country: 'BR',
      id: 'AP',
      name: 'Amapa',
    },
    {
      country: 'BR',
      id: 'AM',
      name: 'Amazonas',
    },
    {
      country: 'BR',
      id: 'BA',
      name: 'Bahia',
    },
    {
      country: 'BR',
      id: 'CE',
      name: 'Ceara',
    },
    {
      country: 'BR',
      id: 'BRDF',
      name: 'Distrito Federal',
    },
    {
      country: 'BR',
      id: 'ES',
      name: 'Espirito Santo',
    },
    {
      country: 'BR',
      id: 'GO',
      name: 'Goias;',
    },
    {
      country: 'BR',
      id: 'MA',
      name: 'Maranhao',
    },
    {
      country: 'BR',
      id: 'MT',
      name: 'Mato Grosso',
    },
    {
      country: 'BR',
      id: 'MS',
      name: 'Mato Grosso do Sul',
    },
    {
      country: 'BR',
      id: 'MG',
      name: 'Minas Gerais',
    },
    {
      country: 'BR',
      id: 'PA',
      name: 'Para;',
    },
    {
      country: 'BR',
      id: 'PB',
      name: 'Paraiba',
    },
    {
      country: 'BR',
      id: 'PR',
      name: 'Parana',
    },
    {
      country: 'BR',
      id: 'PE',
      name: 'Pernambuco',
    },
    {
      country: 'BR',
      id: 'PI',
      name: 'Piaui',
    },
    {
      country: 'BR',
      id: 'RJ',
      name: 'Rio de Janeiro',
    },
    {
      country: 'BR',
      id: 'RN',
      name: 'Rio Grande do Norte',
    },
    {
      country: 'BR',
      id: 'RS',
      name: 'Rio Grande do Sul',
    },
    {
      country: 'BR',
      id: 'RO',
      name: 'Rondonia',
    },
    {
      country: 'BR',
      id: 'RR',
      name: 'Roraima',
    },
    {
      country: 'BR',
      id: 'SC',
      name: 'Santa Catarina',
    },
    {
      country: 'BR',
      id: 'SP',
      name: 'Sao Paulo',
    },
    {
      country: 'BR',
      id: 'SE',
      name: 'Sergipe',
    },
    {
      country: 'BR',
      id: 'TO',
      name: 'Tocantins',
    },
    {
      country: 'GT',
      id: 'Alta Verapaz',
      name: 'Alta Verapaz',
    },
    {
      country: 'GT',
      id: 'Baja Verapaz',
      name: 'Baja Verapaz',
    },
    {
      country: 'GT',
      id: 'Chimaltenango',
      name: 'Chimaltenango',
    },
    {
      country: 'GT',
      id: 'Chiquimula',
      name: 'Chiquimula',
    },
    {
      country: 'GT',
      id: 'El Progreso',
      name: 'El Progreso',
    },
    {
      country: 'GT',
      id: 'Escuintla',
      name: 'Escuintla',
    },
    {
      country: 'GT',
      id: 'Guatemala',
      name: 'Guatemala',
    },
    {
      country: 'GT',
      id: 'Huehuetenango',
      name: 'Huehuetenango',
    },
    {
      country: 'GT',
      id: 'Izabal',
      name: 'Izabal',
    },
    {
      country: 'GT',
      id: 'Jalapa',
      name: 'Jalapa',
    },
    {
      country: 'GT',
      id: 'Jutiapa',
      name: 'Jutiapa',
    },
    {
      country: 'GT',
      id: 'Peten',
      name: 'Peten',
    },
    {
      country: 'GT',
      id: 'Quetzaltenango',
      name: 'Quetzaltenango',
    },
    {
      country: 'GT',
      id: 'Quiche',
      name: 'Quiche',
    },
    {
      country: 'GT',
      id: 'Retalhuleu',
      name: 'Retalhuleu',
    },
    {
      country: 'GT',
      id: 'Sacatepequez',
      name: 'Sacatepequez',
    },
    {
      country: 'GT',
      id: 'San Marcos',
      name: 'San Marcos',
    },
    {
      country: 'GT',
      id: 'Santa Rosa',
      name: 'Santa Rosa',
    },
    {
      country: 'GT',
      id: 'Solola',
      name: 'Solola',
    },
    {
      country: 'GT',
      id: 'Suchitepequez',
      name: 'Suchitepequez',
    },
    {
      country: 'GT',
      id: 'Totonicapan',
      name: 'Totonicapan',
    },
    {
      country: 'GT',
      id: 'Zacapa',
      name: 'Zacapa',
    },
    {
      country: 'IN',
      id: 'AN',
      name: 'Andaman and Nicobar',
    },
    {
      country: 'IN',
      id: 'AP',
      name: 'Andhra Pradesh',
    },
    {
      country: 'IN',
      id: 'AR',
      name: 'Arunachal Pradesh',
    },
    {
      country: 'IN',
      id: 'AS',
      name: 'Assam',
    },
    {
      country: 'IN',
      id: 'BR',
      name: 'Bihar',
    },
    {
      country: 'IN',
      id: 'CH',
      name: 'Chandigarh',
    },
    {
      country: 'IN',
      id: 'CT',
      name: 'Chattisgarh',
    },
    {
      country: 'IN',
      id: 'DN',
      name: 'Dadra and Nagar Haveli',
    },
    {
      country: 'IN',
      id: 'DD',
      name: 'Daman and Diu',
    },
    {
      country: 'IN',
      id: 'DL',
      name: 'Delhi',
    },
    {
      country: 'IN',
      id: 'GA',
      name: 'Goa',
    },
    {
      country: 'IN',
      id: 'GJ',
      name: 'Gujarat',
    },
    {
      country: 'IN',
      id: 'HR',
      name: 'Haryana',
    },
    {
      country: 'IN',
      id: 'HP',
      name: 'Himachal Pradesh',
    },
    {
      country: 'IN',
      id: 'JK',
      name: 'Jammu and Kashmir',
    },
    {
      country: 'IN',
      id: 'JH',
      name: 'Jharkhand',
    },
    {
      country: 'IN',
      id: 'KA',
      name: 'Karnataka',
    },
    {
      country: 'IN',
      id: 'KL',
      name: 'Kerala',
    },
    {
      country: 'IN',
      id: 'LD',
      name: 'Lakshadweep',
    },
    {
      country: 'IN',
      id: 'MP',
      name: 'Madhya Pradesh',
    },
    {
      country: 'IN',
      id: 'MH',
      name: 'Maharashtra',
    },
    {
      country: 'IN',
      id: 'MN',
      name: 'Manipur',
    },
    {
      country: 'IN',
      id: 'ML',
      name: 'Meghalaya',
    },
    {
      country: 'IN',
      id: 'MZ',
      name: 'Mizoram',
    },
    {
      country: 'IN',
      id: 'NL',
      name: 'Nagaland',
    },
    {
      country: 'IN',
      id: 'OR',
      name: 'Orissa',
    },
    {
      country: 'IN',
      id: 'PY',
      name: 'Puducherry',
    },
    {
      country: 'IN',
      id: 'PB',
      name: 'Punjab',
    },
    {
      country: 'IN',
      id: 'RJ',
      name: 'Rajasthan',
    },
    {
      country: 'IN',
      id: 'SK',
      name: 'Sikkim',
    },
    {
      country: 'IN',
      id: 'TN',
      name: 'Tamil Nadu',
    },
    {
      country: 'IN',
      id: 'TR',
      name: 'Tripura',
    },
    {
      country: 'IN',
      id: 'UP',
      name: 'Uttar Pradesh',
    },
    {
      country: 'IN',
      id: 'UT',
      name: 'Uttarakhand',
    },
    {
      country: 'IN',
      id: 'WB',
      name: 'West Bengal',
    },
    {
      country: 'MY',
      id: 'JHR',
      name: 'Johor',
    },
    {
      country: 'MY',
      id: 'KDH',
      name: 'Kedah',
    },
    {
      country: 'MY',
      id: 'KTN',
      name: 'Kelantan',
    },
    {
      country: 'MY',
      id: 'KUL',
      name: 'Kuala Lumpur',
    },
    {
      country: 'MY',
      id: 'LBN',
      name: 'Labuan',
    },
    {
      country: 'MY',
      id: 'MLK',
      name: 'Malacca',
    },
    {
      country: 'MY',
      id: 'NSN',
      name: 'Negeri Sembilan',
    },
    {
      country: 'MY',
      id: 'PHG',
      name: 'Pahang',
    },
    {
      country: 'MY',
      id: 'PNG',
      name: 'Penang',
    },
    {
      country: 'MY',
      id: 'PRK',
      name: 'Perak',
    },
    {
      country: 'MY',
      id: 'PLS',
      name: 'Perlis',
    },
    {
      country: 'MY',
      id: 'PJY',
      name: 'Putrajaya',
    },
    {
      country: 'MY',
      id: 'SBH',
      name: 'Sabah',
    },
    {
      country: 'MY',
      id: 'SRW',
      name: 'Sarawak',
    },
    {
      country: 'MY',
      id: 'SGR',
      name: 'Selangor',
    },
    {
      country: 'MY',
      id: 'TRG',
      name: 'Terengganu',
    },
    {
      country: 'MX',
      id: 'AG',
      name: 'Aguascalientes',
    },
    {
      country: 'MX',
      id: 'BJ',
      name: 'Baja California',
    },
    {
      country: 'MX',
      id: 'BS',
      name: 'Baja California Sur',
    },
    {
      country: 'MX',
      id: 'CI',
      name: 'Chihuahua',
    },
    {
      country: 'MX',
      id: 'CL',
      name: 'Colima',
    },
    {
      country: 'MX',
      id: 'CP',
      name: 'Campeche',
    },
    {
      country: 'MX',
      id: 'CU',
      name: 'Coahuila',
    },
    {
      country: 'MX',
      id: 'CH',
      name: 'Chiapas',
    },
    {
      country: 'MX',
      id: 'DF',
      name: 'Distrito Federal',
    },
    {
      country: 'MX',
      id: 'DG',
      name: 'Durango',
    },
    {
      country: 'MX',
      id: 'GR',
      name: 'Guerrero',
    },
    {
      country: 'MX',
      id: 'GJ',
      name: 'Guanajuato',
    },
    {
      country: 'MX',
      id: 'HG',
      name: 'Hidalgo',
    },
    {
      country: 'MX',
      id: 'JA',
      name: 'Jalisco',
    },
    {
      country: 'MX',
      id: 'MH',
      name: 'Michoacan',
    },
    {
      country: 'MX',
      id: 'MR',
      name: 'Morelos',
    },
    {
      country: 'MX',
      id: 'EM',
      name: 'Mexico',
    },
    {
      country: 'MX',
      id: 'NA',
      name: 'Nayarit',
    },
    {
      country: 'MX',
      id: 'NL',
      name: 'Nuevo Leon',
    },
    {
      country: 'MX',
      id: 'OA',
      name: 'Oaxaca',
    },
    {
      country: 'MX',
      id: 'PU',
      name: 'Puebla',
    },
    {
      country: 'MX',
      id: 'QR',
      name: 'Quintana Roo',
    },
    {
      country: 'MX',
      id: 'QA',
      name: 'Queretaro',
    },
    {
      country: 'MX',
      id: 'SI',
      name: 'Sinaloa',
    },
    {
      country: 'MX',
      id: 'SL',
      name: 'San Luis Potosi',
    },
    {
      country: 'MX',
      id: 'SO',
      name: 'Sonora',
    },
    {
      country: 'MX',
      id: 'TA',
      name: 'Tabasco',
    },
    {
      country: 'MX',
      id: 'TL',
      name: 'Tlaxcala',
    },
    {
      country: 'MX',
      id: 'TM',
      name: 'Tamaulipas',
    },
    {
      country: 'MX',
      id: 'VZ',
      name: 'Veracruz',
    },
    {
      country: 'MX',
      id: 'YC',
      name: 'Yucatan',
    },
    {
      country: 'MX',
      id: 'ZT',
      name: 'Zacatecas',
    },
    {
      country: 'NZ',
      id: 'AUK',
      name: 'Auckland',
    },
    {
      country: 'NZ',
      id: 'BOP',
      name: 'Bay of Plenty',
    },
    {
      country: 'NZ',
      id: 'CAN',
      name: 'Canterbury',
    },
    {
      country: 'NZ',
      id: 'GIS',
      name: 'Gisborne',
    },
    {
      country: 'NZ',
      id: 'HKB',
      name: "Hawke's Bay",
    },
    {
      country: 'NZ',
      id: 'MWT',
      name: 'Manawatu-Wanganui',
    },
    {
      country: 'NZ',
      id: 'MBH',
      name: 'Marlborough',
    },
    {
      country: 'NZ',
      id: 'NSN',
      name: 'Nelson',
    },
    {
      country: 'NZ',
      id: 'NTL',
      name: 'Northland',
    },
    {
      country: 'NZ',
      id: 'OTA',
      name: 'Otago',
    },
    {
      country: 'NZ',
      id: 'STL',
      name: 'Southland',
    },
    {
      country: 'NZ',
      id: 'TKI',
      name: 'Taranaki',
    },
    {
      country: 'NZ',
      id: 'NZTAS',
      name: 'Tasman',
    },
    {
      country: 'NZ',
      id: 'WKO',
      name: 'Waikato',
    },
    {
      country: 'NZ',
      id: 'WGN',
      name: 'Wellington',
    },
    {
      country: 'NZ',
      id: 'WTC',
      name: 'West Coast',
    },
    {
      country: 'ES',
      id: 'A Coruna',
      name: 'A Coruna',
    },
    {
      country: 'ES',
      id: 'Alava',
      name: 'Alava',
    },
    {
      country: 'ES',
      id: 'Albacete',
      name: 'Albacete',
    },
    {
      country: 'ES',
      id: 'Alicante',
      name: 'Alicante',
    },
    {
      country: 'ES',
      id: 'Almeria',
      name: 'Almeria',
    },
    {
      country: 'ES',
      id: 'Asturias',
      name: 'Asturias',
    },
    {
      country: 'ES',
      id: 'Avila',
      name: 'Avila',
    },
    {
      country: 'ES',
      id: 'Badajoz',
      name: 'Badajoz',
    },
    {
      country: 'ES',
      id: 'Baleares',
      name: 'Baleares',
    },
    {
      country: 'ES',
      id: 'Barcelona',
      name: 'Barcelona',
    },
    {
      country: 'ES',
      id: 'Burgos',
      name: 'Burgos',
    },
    {
      country: 'ES',
      id: 'Caceres',
      name: 'Caceres',
    },
    {
      country: 'ES',
      id: 'Cadiz',
      name: 'Cadiz',
    },
    {
      country: 'ES',
      id: 'Cantabria',
      name: 'Cantabria',
    },
    {
      country: 'ES',
      id: 'Castellon',
      name: 'Castellon',
    },
    {
      country: 'ES',
      id: 'Ceuta',
      name: 'Ceuta',
    },
    {
      country: 'ES',
      id: 'Ciudad Real',
      name: 'Ciudad Real',
    },
    {
      country: 'ES',
      id: 'Cordoba',
      name: 'Cordoba',
    },
    {
      country: 'ES',
      id: 'Cuenca',
      name: 'Cuenca',
    },
    {
      country: 'ES',
      id: 'Girona',
      name: 'Girona',
    },
    {
      country: 'ES',
      id: 'Granada',
      name: 'Granada',
    },
    {
      country: 'ES',
      id: 'Guadalajara',
      name: 'Guadalajara',
    },
    {
      country: 'ES',
      id: 'Guipuzcoa',
      name: 'Guipuzcoa',
    },
    {
      country: 'ES',
      id: 'Huelva',
      name: 'Huelva',
    },
    {
      country: 'ES',
      id: 'Huesca',
      name: 'Huesca',
    },
    {
      country: 'ES',
      id: 'Jaen',
      name: 'Jaen',
    },
    {
      country: 'ES',
      id: 'La Rioja',
      name: 'La Rioja',
    },
    {
      country: 'ES',
      id: 'Las Palmas',
      name: 'Las Palmas',
    },
    {
      country: 'ES',
      id: 'Leon',
      name: 'Leon',
    },
    {
      country: 'ES',
      id: 'Lleida',
      name: 'Lleida',
    },
    {
      country: 'ES',
      id: 'Lugo',
      name: 'Lugo',
    },
    {
      country: 'ES',
      id: 'Madrid',
      name: 'Madrid',
    },
    {
      country: 'ES',
      id: 'Malaga',
      name: 'Malaga',
    },
    {
      country: 'ES',
      id: 'Melilla',
      name: 'Melilla',
    },
    {
      country: 'ES',
      id: 'Murcia',
      name: 'Murcia',
    },
    {
      country: 'ES',
      id: 'Navarra',
      name: 'Navarra',
    },
    {
      country: 'ES',
      id: 'Ourense',
      name: 'Ourense',
    },
    {
      country: 'ES',
      id: 'Palencia',
      name: 'Palencia',
    },
    {
      country: 'ES',
      id: 'Pontevedra',
      name: 'Pontevedra',
    },
    {
      country: 'ES',
      id: 'Salamanca',
      name: 'Salamanca',
    },
    {
      country: 'ES',
      id: 'Santa Cruz de Tenerife',
      name: 'Santa Cruz de Tenerife',
    },
    {
      country: 'ES',
      id: 'Segovia',
      name: 'Segovia',
    },
    {
      country: 'ES',
      id: 'Sevilla',
      name: 'Sevilla',
    },
    {
      country: 'ES',
      id: 'Soria',
      name: 'Soria',
    },
    {
      country: 'ES',
      id: 'Tarragona',
      name: 'Tarragona',
    },
    {
      country: 'ES',
      id: 'Teruel',
      name: 'Teruel',
    },
    {
      country: 'ES',
      id: 'Toledo',
      name: 'Toledo',
    },
    {
      country: 'ES',
      id: 'Valencia',
      name: 'Valencia',
    },
    {
      country: 'ES',
      id: 'Valladolid',
      name: 'Valladolid',
    },
    {
      country: 'ES',
      id: 'Vizcaya',
      name: 'Vizcaya',
    },
    {
      country: 'ES',
      id: 'Zamora',
      name: 'Zamora',
    },
    {
      country: 'ES',
      id: 'Zaragoza',
      name: 'Zaragoza',
    },
    {
      country: 'AE',
      id: 'Abu Dhabi',
      name: 'Abu Dhabi',
    },
    {
      country: 'AE',
      id: 'Ajman',
      name: 'Ajman',
    },
    {
      country: 'AE',
      id: 'Dubai',
      name: 'Dubai',
    },
    {
      country: 'AE',
      id: 'Fujairah',
      name: 'Fujairah',
    },
    {
      country: 'AE',
      id: 'Ras al-Khaimah',
      name: 'Ras al-Khaimah',
    },
    {
      country: 'AE',
      id: 'Sharjah',
      name: 'Sharjah',
    },
    {
      country: 'AE',
      id: 'Umm al-Quwain',
      name: 'Umm al-Quwain',
    },
    {
      country: 'DZ',
      id: 'DZ-01',
      name: 'Adrar',
    },
    {
      country: 'DZ',
      id: 'DZ-44',
      name: 'Aïn Defla',
    },
    {
      country: 'DZ',
      id: 'DZ-46',
      name: 'Aïn Témouchent',
    },
    {
      country: 'DZ',
      id: 'DZ-16',
      name: 'Algiers',
    },
    {
      country: 'DZ',
      id: 'DZ-23',
      name: 'Annaba',
    },
    {
      country: 'DZ',
      id: 'DZ-05',
      name: 'Batna',
    },
    {
      country: 'DZ',
      id: 'DZ-08',
      name: 'Béchar',
    },
    {
      country: 'DZ',
      id: 'DZ-06',
      name: 'Béjaïa',
    },
    {
      country: 'DZ',
      id: 'DZ-53',
      name: 'Béni Abbès',
    },
    {
      country: 'DZ',
      id: 'DZ-07',
      name: 'Biskra',
    },
    {
      country: 'DZ',
      id: 'DZ-09',
      name: 'Blida',
    },
    {
      country: 'DZ',
      id: 'DZ-52',
      name: 'Bordj Baji Mokhtar',
    },
    {
      country: 'DZ',
      id: 'DZ-34',
      name: 'Bordj Bou Arréridj',
    },
    {
      country: 'DZ',
      id: 'DZ-10',
      name: 'Bouïra',
    },
    {
      country: 'DZ',
      id: 'DZ-35',
      name: 'Boumerdès',
    },
    {
      country: 'DZ',
      id: 'DZ-02',
      name: 'Chlef',
    },
    {
      country: 'DZ',
      id: 'DZ-25',
      name: 'Constantine',
    },
    {
      country: 'DZ',
      id: 'DZ-56',
      name: 'Djanet',
    },
    {
      country: 'DZ',
      id: 'DZ-17',
      name: 'Djelfa',
    },
    {
      country: 'DZ',
      id: 'DZ-32',
      name: 'El Bayadh',
    },
    {
      country: 'DZ',
      id: 'DZ-49',
      name: "El M'Ghair",
    },
    {
      country: 'DZ',
      id: 'DZ-50',
      name: 'El Menia',
    },
    {
      country: 'DZ',
      id: 'DZ-39',
      name: 'El Oued',
    },
    {
      country: 'DZ',
      id: 'DZ-36',
      name: 'El Tarf',
    },
    {
      country: 'DZ',
      id: 'DZ-47',
      name: 'Ghardaïa',
    },
    {
      country: 'DZ',
      id: 'DZ-24',
      name: 'Guelma',
    },
    {
      country: 'DZ',
      id: 'DZ-33',
      name: 'Illizi',
    },
    {
      country: 'DZ',
      id: 'DZ-58',
      name: 'In Guezzam',
    },
    {
      country: 'DZ',
      id: 'DZ-57',
      name: 'In Salah',
    },
    {
      country: 'DZ',
      id: 'DZ-18',
      name: 'Jijel',
    },
    {
      country: 'DZ',
      id: 'DZ-40',
      name: 'Khenchela',
    },
    {
      country: 'DZ',
      id: 'DZ-03',
      name: 'Laghouat',
    },
    {
      country: 'DZ',
      id: 'DZ-28',
      name: "M'Sila",
    },
    {
      country: 'DZ',
      id: 'DZ-29',
      name: 'Mascara',
    },
    {
      country: 'DZ',
      id: 'DZ-26',
      name: 'Médéa',
    },
    {
      country: 'DZ',
      id: 'DZ-43',
      name: 'Mila',
    },
    {
      country: 'DZ',
      id: 'DZ-27',
      name: 'Mostaganem',
    },
    {
      country: 'DZ',
      id: 'DZ-45',
      name: 'Naâma',
    },
    {
      country: 'DZ',
      id: 'DZ-31',
      name: 'Oran',
    },
    {
      country: 'DZ',
      id: 'DZ-30',
      name: 'Ouargla',
    },
    {
      country: 'DZ',
      id: 'DZ-51',
      name: 'Ouled Djellal',
    },
    {
      country: 'DZ',
      id: 'DZ-04',
      name: 'Oum El Bouaghi',
    },
    {
      country: 'DZ',
      id: 'DZ-48',
      name: 'Relizane',
    },
    {
      country: 'DZ',
      id: 'DZ-20',
      name: 'Saïda',
    },
    {
      country: 'DZ',
      id: 'DZ-19',
      name: 'Sétif',
    },
    {
      country: 'DZ',
      id: 'DZ-22',
      name: 'Sidi Bel Abbès',
    },
    {
      country: 'DZ',
      id: 'DZ-21',
      name: 'Skikda',
    },
    {
      country: 'DZ',
      id: 'DZ-41',
      name: 'Souk Ahras',
    },
    {
      country: 'DZ',
      id: 'DZ-11',
      name: 'Tamanrasset',
    },
    {
      country: 'DZ',
      id: 'DZ-12',
      name: 'Tébessa',
    },
    {
      country: 'DZ',
      id: 'DZ-14',
      name: 'Tiaret',
    },
    {
      country: 'DZ',
      id: 'DZ-54',
      name: 'Timimoun',
    },
    {
      country: 'DZ',
      id: 'DZ-37',
      name: 'Tindouf',
    },
    {
      country: 'DZ',
      id: 'DZ-42',
      name: 'Tipaza',
    },
    {
      country: 'DZ',
      id: 'DZ-38',
      name: 'Tissemsilt',
    },
    {
      country: 'DZ',
      id: 'DZ-15',
      name: 'Tizi Ouzou',
    },
    {
      country: 'DZ',
      id: 'DZ-13',
      name: 'Tlemcen',
    },
    {
      country: 'DZ',
      id: 'DZ-55',
      name: 'Touggourt',
    },
    {
      country: 'PH',
      id: 'PH-00',
      name: 'National Capital Region [NCR]',
    },
    {
      country: 'PH',
      id: 'PH-01',
      name: 'Ilocos [I]',
    },
    {
      country: 'PH',
      id: 'PH-02',
      name: 'Cagayan Valley [II]',
    },
    {
      country: 'PH',
      id: 'PH-03',
      name: 'Central Luzon [III]',
    },
    {
      country: 'PH',
      id: 'PH-05',
      name: 'Bicol [V]',
    },
    {
      country: 'PH',
      id: 'PH-06',
      name: 'Western Visayas [VI]',
    },
    {
      country: 'PH',
      id: 'PH-07',
      name: 'Central Visayas [VII]',
    },
    {
      country: 'PH',
      id: 'PH-08',
      name: 'Eastern Visayas [VIII]',
    },
    {
      country: 'PH',
      id: 'PH-09',
      name: 'Zamboanga Peninsula [IX]',
    },
    {
      country: 'PH',
      id: 'PH-10',
      name: 'Northern Mindanao [X]',
    },
    {
      country: 'PH',
      id: 'PH-11',
      name: 'Davao [XI]',
    },
    {
      country: 'PH',
      id: 'PH-12',
      name: 'Soccsksargen [XII]',
    },
    {
      country: 'PH',
      id: 'PH-13',
      name: 'Caraga [XIII]',
    },
    {
      country: 'PH',
      id: 'PH-14',
      name: 'Autonomous Region in Muslim Mindanao [ARMM]',
    },
    {
      country: 'PH',
      id: 'PH-15',
      name: 'Cordillera Administrative Region [CAR]',
    },
    {
      country: 'PH',
      id: 'PH-40',
      name: 'Calabarzon [IV-A]',
    },
    {
      country: 'PH',
      id: 'PH-41',
      name: 'Mimaropa [IV-B]',
    },
  ],
  timezones: [
    {
      id: 'Pacific/Kiritimati',
      name: 'Line Islands Time',
    },
    {
      id: 'Pacific/Enderbury',
      name: 'Phoenix Islands Time',
    },
    {
      id: 'Pacific/Tongatapu',
      name: 'Tonga Time',
    },
    {
      id: 'Pacific/Chatham',
      name: 'Chatham Daylight Time',
    },
    {
      id: 'Asia/Kamchatka',
      name: 'Petropavlovsk-Kamchatski Time',
    },
    {
      id: 'Pacific/Auckland',
      name: 'New Zealand Daylight Time',
    },
    {
      id: 'Pacific/Fiji',
      name: 'Fiji Time',
    },
    {
      id: 'Pacific/Norfolk',
      name: 'Norfolk Time',
    },
    {
      id: 'Pacific/Guadalcanal',
      name: 'Solomon Islands Time',
    },
    {
      id: 'Australia/Lord_Howe',
      name: 'Lord Howe Summer Time',
    },
    {
      id: 'Australia/Brisbane',
      name: 'Australian Eastern Standard Time (Brisbane)',
    },
    {
      id: 'Australia/Sydney',
      name: 'Australian Eastern Standard Time (Sydney)',
    },
    {
      id: 'Australia/Adelaide',
      name: 'Australian Central Standard Time (Adelaide)',
    },
    {
      id: 'Australia/Darwin',
      name: 'Australian Central Standard Time (Darwin)',
    },
    {
      id: 'Asia/Seoul',
      name: 'Korea Standard Time',
    },
    {
      id: 'Asia/Tokyo',
      name: 'Japan Standard Time',
    },
    {
      id: 'Asia/Hong_Kong',
      name: 'Hong Kong Time',
    },
    {
      id: 'Asia/Kuala_Lumpur',
      name: 'Malaysia Time',
    },
    {
      id: 'Asia/Manila',
      name: 'Philippines Time',
    },
    {
      id: 'Asia/Shanghai',
      name: 'China Standard Time (Shanghai)',
    },
    {
      id: 'Asia/Singapore',
      name: 'Singapore Time',
    },
    {
      id: 'Asia/Taipei',
      name: 'China Standard Time (Taipei)',
    },
    {
      id: 'Australia/Perth',
      name: 'Australian Western Standard Time',
    },
    {
      id: 'Asia/Bangkok',
      name: 'Indochina Time (Bangkok)',
    },
    {
      id: 'Asia/Jakarta',
      name: 'West Indonesia Time',
    },
    {
      id: 'Asia/Saigon',
      name: 'Indochina Time (Saigon)',
    },
    {
      id: 'Asia/Rangoon',
      name: 'Myanmar Time',
    },
    {
      id: 'Asia/Dacca',
      name: 'Bangladesh Time',
    },
    {
      id: 'Asia/Katmandu',
      name: 'Nepal Time',
    },
    {
      id: 'Asia/Calcutta',
      name: 'India Standard Time (Calcutta)',
    },
    {
      id: 'Asia/Colombo',
      name: 'India Standard Time (Colombo)',
    },
    {
      id: 'Asia/Karachi',
      name: 'Pakistan Summer Time',
    },
    {
      id: 'Asia/Tashkent',
      name: 'Uzbekistan Time',
    },
    {
      id: 'Asia/Yekaterinburg',
      name: 'Yekaterinburg Time',
    },
    {
      id: 'Asia/Kabul',
      name: 'Afghanistan Time',
    },
    {
      id: 'Asia/Baku',
      name: 'Azerbaijan Time',
    },
    {
      id: 'Asia/Dubai',
      name: 'Gulf Standard Time',
    },
    {
      id: 'Asia/Tbilisi',
      name: 'Georgia Time',
    },
    {
      id: 'Asia/Yerevan',
      name: 'Armenia Time',
    },
    {
      id: 'Asia/Tehran',
      name: 'Iran Standard Time',
    },
    {
      id: 'Africa/Nairobi',
      name: 'Eastern African Time',
    },
    {
      id: 'Asia/Baghdad',
      name: 'Arabia Standard Time (Baghdad)',
    },
    {
      id: 'Asia/Kuwait',
      name: 'Arabia Standard Time (Kuwait)',
    },
    {
      id: 'Asia/Riyadh',
      name: 'Arabia Standard Time (Riyadh)',
    },
    {
      id: 'Europe/Moscow',
      name: 'Moscow Standard Time',
    },
    {
      id: 'Africa/Cairo',
      name: 'Eastern European Time (Cairo)',
    },
    {
      id: 'Africa/Johannesburg',
      name: 'South Africa Standard Time',
    },
    {
      id: 'Asia/Beirut',
      name: 'Eastern European Time (Beirut)',
    },
    {
      id: 'Asia/Jerusalem',
      name: 'Israel Standard Time',
    },
    {
      id: 'Europe/Athens',
      name: 'Eastern European Time (Athens)',
    },
    {
      id: 'Europe/Bucharest',
      name: 'Eastern European Time (Bucharest)',
    },
    {
      id: 'Europe/Helsinki',
      name: 'Eastern European Time (Helsinki)',
    },
    {
      id: 'Europe/Istanbul',
      name: 'Eastern European Time (Istanbul)',
    },
    {
      id: 'Europe/Minsk',
      name: 'Eastern European Time (Minsk)',
    },
    {
      id: 'Europe/Amsterdam',
      name: 'Central European Time (Amsterdam)',
    },
    {
      id: 'Europe/Berlin',
      name: 'Central European Time (Berlin)',
    },
    {
      id: 'Europe/Brussels',
      name: 'Central European Time (Brussels)',
    },
    {
      id: 'Europe/Prague',
      name: 'Central European Time (Prague)',
    },
    {
      id: 'Europe/Rome',
      name: 'Central European Time (Rome)',
    },
    {
      id: 'Europe/Dublin',
      name: 'Irish Summer Time',
    },
    {
      id: 'Europe/Lisbon',
      name: 'Western European Summer Time',
    },
    {
      id: 'Europe/London',
      name: 'British Summer Time',
    },
    {
      id: 'GMT',
      name: 'Greenwich Mean Time',
    },
    {
      id: 'America/Scoresbysund',
      name: 'East Greenland Time',
    },
    {
      id: 'Atlantic/Azores',
      name: 'Azores Time',
    },
    {
      id: 'Atlantic/Cape_Verde',
      name: 'Cape Verde Time',
    },
    {
      id: 'Atlantic/South_Georgia',
      name: 'South Georgia Standard Time',
    },
    {
      id: 'America/Buenos_Aires',
      name: 'Argentine Summer Time',
    },
    {
      id: 'America/Sao_Paulo',
      name: 'Brasilia Summer Time',
    },
    {
      id: 'America/St_Johns',
      name: 'Newfoundland Daylight Time',
    },
    {
      id: 'America/Halifax',
      name: 'Atlantic Daylight Time (Halifax)',
    },
    {
      id: 'America/Puerto_Rico',
      name: 'Atlantic Standard Time',
    },
    {
      id: 'America/Santiago',
      name: 'Chile Summer Time',
    },
    {
      id: 'Atlantic/Bermuda',
      name: 'Atlantic Daylight Time (Bermuda)',
    },
    {
      id: 'America/Caracas',
      name: 'Venezuela Time',
    },
    {
      id: 'America/Bogota',
      name: 'Colombia Time',
    },
    {
      id: 'America/Indianapolis',
      name: 'Eastern Daylight Time (Indianapolis)',
    },
    {
      id: 'America/Lima',
      name: 'Peru Time',
    },
    {
      id: 'America/New_York',
      name: 'Eastern Daylight Time (New York)',
    },
    {
      id: 'America/Panama',
      name: 'Eastern Standard Time (Panama)',
    },
    {
      id: 'America/Chicago',
      name: 'Central Daylight Time (Chicago)',
    },
    {
      id: 'America/El_Salvador',
      name: 'Central Standard Time (El Salvador)',
    },
    {
      id: 'America/Mexico_City',
      name: 'Central Standard Time (Mexico City)',
    },
    {
      id: 'America/Denver',
      name: 'Mountain Daylight Time',
    },
    {
      id: 'America/Phoenix',
      name: 'Mountain Standard Time',
    },
    {
      id: 'America/Los_Angeles',
      name: 'Pacific Daylight Time',
    },
    {
      id: 'America/Tijuana',
      name: 'Pacific Standard Time',
    },
    {
      id: 'Pacific/Pitcairn',
      name: 'Pitcairn Standard Time',
    },
    {
      id: 'America/Anchorage',
      name: 'Alaska Daylight Time',
    },
    {
      id: 'Pacific/Gambier',
      name: 'Gambier Time',
    },
    {
      id: 'Pacific/Marquesas',
      name: 'Marquesas Time',
    },
    {
      id: 'Pacific/Honolulu',
      name: 'Hawaii Standard Time',
    },
    {
      id: 'America/Atka',
      name: 'Hawaii-Aleutian Standard Time',
    },
    {
      id: 'Pacific/Niue',
      name: 'Niue Time',
    },
    {
      id: 'Pacific/Pago_Pago',
      name: 'Samoa Standard Time',
    },
  ],
  locales: [
    {
      id: 'af',
      name: 'Afrikaans',
    },
    {
      id: 'af-ZA',
      name: 'Afrikaans (South Africa)',
    },
    {
      id: 'az',
      name: 'Azerbaijani',
    },
    {
      id: 'az-AZ',
      name: 'Azerbaijani (Azerbaijani)',
    },
    {
      id: 'id',
      name: 'Indonesian',
    },
    {
      id: 'id-ID',
      name: 'Indonesian (Indonesia)',
    },
    {
      id: 'ms',
      name: 'Malay',
    },
    {
      id: 'ms-MY',
      name: 'Malay (Malaysia)',
    },
    {
      id: 'ca',
      name: 'Catalan',
    },
    {
      id: 'ca-ES',
      name: 'Catalan (Spain)',
    },
    {
      id: 'cs',
      name: 'Czech',
    },
    {
      id: 'cs-CZ',
      name: 'Czech (Czech Republic)',
    },
    {
      id: 'da',
      name: 'Danish',
    },
    {
      id: 'da-DK',
      name: 'Danish (Denmark)',
    },
    {
      id: 'de',
      name: 'German',
    },
    {
      id: 'de-DE',
      name: 'German (Germany)',
    },
    {
      id: 'de-CH',
      name: 'German (Switzerland)',
    },
    {
      id: 'de-AT',
      name: 'German (Austria)',
    },
    {
      id: 'et',
      name: 'Estonian',
    },
    {
      id: 'et-EE',
      name: 'Estonian (Estonia)',
    },
    {
      id: 'en',
      name: 'English',
    },
    {
      id: 'en-AU',
      name: 'English (Australia)',
    },
    {
      id: 'en-CA',
      name: 'English (Canada)',
    },
    {
      id: 'en-IE',
      name: 'English (Ireland)',
    },
    {
      id: 'en-NZ',
      name: 'English (New Zealand)',
    },
    {
      id: 'en-GB',
      name: 'English (United Kingdom)',
    },
    {
      id: 'en-US',
      name: 'English (United States)',
    },
    {
      id: 'es',
      name: 'Spanish',
    },
    {
      id: 'es-AR',
      name: 'Spanish (Argentina)',
    },
    {
      id: 'es-CL',
      name: 'Spanish (Chile)',
    },
    {
      id: 'es-CO',
      name: 'Spanish (Colombia)',
    },
    {
      id: 'es-CR',
      name: 'Spanish (Costa Rica)',
    },
    {
      id: 'es-ES',
      name: 'Spanish (Spain)',
    },
    {
      id: 'es-MX',
      name: 'Spanish (Mexico)',
    },
    {
      id: 'es-PA',
      name: 'Spanish (Panama)',
    },
    {
      id: 'es-PE',
      name: 'Spanish (Peru)',
    },
    {
      id: 'es-VE',
      name: 'Spanish (Venezuela)',
    },
    {
      id: 'fil',
      name: 'Filipino',
    },
    {
      id: 'fil-PH',
      name: 'Filipino (Philippines)',
    },
    {
      id: 'fr',
      name: 'French',
    },
    {
      id: 'fr-CA',
      name: 'French (Canada)',
    },
    {
      id: 'fr-FR',
      name: 'French (France)',
    },
    {
      id: 'fr-CH',
      name: 'French (Switzerland)',
    },
    {
      id: 'gl',
      name: 'Galician',
    },
    {
      id: 'gl-ES',
      name: 'Galician (Spain)',
    },
    {
      id: 'hr',
      name: 'Croatian',
    },
    {
      id: 'hr-HR',
      name: 'Croatian (Croatia)',
    },
    {
      id: 'it',
      name: 'Italian',
    },
    {
      id: 'it-IT',
      name: 'Italian (Italy)',
    },
    {
      id: 'it-CH',
      name: 'Italian (Switzerland)',
    },
    {
      id: 'sw',
      name: 'Swahili',
    },
    {
      id: 'sw-KE',
      name: 'Swahili (Kenya)',
    },
    {
      id: 'sw-KE',
      name: 'Swahili (Tanzania)',
    },
    {
      id: 'lv',
      name: 'Latvian',
    },
    {
      id: 'lv-LV',
      name: 'Latvian (Latvia)',
    },
    {
      id: 'lt',
      name: 'Lithuanian',
    },
    {
      id: 'lt-LT',
      name: 'Lithuanian (Lithuania)',
    },
    {
      id: 'hu',
      name: 'Hungarian',
    },
    {
      id: 'hu-HU',
      name: 'Hungarian (Hungary)',
    },
    {
      id: 'nl',
      name: 'Dutch',
    },
    {
      id: 'nl-NL',
      name: 'Dutch (Netherlands)',
    },
    {
      id: 'nb',
      name: 'Norwegian Bokmål',
    },
    {
      id: 'nb-NO',
      name: 'Norwegian Bokmål (Norway)',
    },
    {
      id: 'nn',
      name: 'Norwegian Nynorsk',
    },
    {
      id: 'nn-NO',
      name: 'Norwegian Nynorsk (Norway)',
    },
    {
      id: 'pl',
      name: 'Polish',
    },
    {
      id: 'pl-PL',
      name: 'Polish (Poland)',
    },
    {
      id: 'pt',
      name: 'Portuguese',
    },
    {
      id: 'pt-BR',
      name: 'Portuguese (Brazil)',
    },
    {
      id: 'pt-PT',
      name: 'Portuguese (Portugal)',
    },
    {
      id: 'ro',
      name: 'Romanian',
    },
    {
      id: 'ro-MD',
      name: 'Romanian (Moldova)',
    },
    {
      id: 'ro-RO',
      name: 'Romanian (Romania)',
    },
    {
      id: 'sq',
      name: 'Albanian',
    },
    {
      id: 'sq-AL',
      name: 'Albanian (Albania)',
    },
    {
      id: 'sk',
      name: 'Slovak',
    },
    {
      id: 'sk-SK',
      name: 'Slovak (Slovakia)',
    },
    {
      id: 'sl',
      name: 'Slovenian',
    },
    {
      id: 'sl-SI',
      name: 'Slovenian (Slovenia)',
    },
    {
      id: 'fi',
      name: 'Finnish',
    },
    {
      id: 'fi-FI',
      name: 'Finnish (Finland)',
    },
    {
      id: 'sv',
      name: 'Swedish',
    },
    {
      id: 'sv-FI',
      name: 'Swedish (Finland)',
    },
    {
      id: 'sv-SE',
      name: 'Swedish (Sweden)',
    },
    {
      id: 'vi',
      name: 'Vietnamese',
    },
    {
      id: 'vi-VN',
      name: 'Vietnamese (Vietnam)',
    },
    {
      id: 'tr',
      name: 'Turkish',
    },
    {
      id: 'tr-TR',
      name: 'Turkish (Turkey)',
    },
    {
      id: 'is',
      name: 'Icelandic',
    },
    {
      id: 'is-IS',
      name: 'Icelandic (Iceland)',
    },
    {
      id: 'el',
      name: 'Greek',
    },
    {
      id: 'el-CY',
      name: 'Greek (Cyprus)',
    },
    {
      id: 'el-GR',
      name: 'Greek (Greece)',
    },
    {
      id: 'sr',
      name: 'Serbian',
    },
    {
      id: 'sr-RS',
      name: 'Serbian (Serbia)',
    },
    {
      id: 'be',
      name: 'Belarusian',
    },
    {
      id: 'be-BY',
      name: 'Belarusian (Belarus)',
    },
    {
      id: 'bg',
      name: 'български',
    },
    {
      id: 'bg-BG',
      name: 'Bulgarian (Bulgaria)',
    },
    {
      id: 'mk',
      name: 'Macedonian',
    },
    {
      id: 'mk-MK',
      name: 'Macedonian (Macedonia)',
    },
    {
      id: 'ru',
      name: 'Russian',
    },
    {
      id: 'ru-MD',
      name: 'Russian (Moldova)',
    },
    {
      id: 'ru-RU',
      name: 'Russian (Russia)',
    },
    {
      id: 'ru-UA',
      name: 'Russian (Ukraine)',
    },
    {
      id: 'uk',
      name: 'Ukrainian',
    },
    {
      id: 'uk-UA',
      name: 'Ukrainian (Ukraine)',
    },
    {
      id: 'he',
      name: 'Hebrew',
    },
    {
      id: 'he-IL',
      name: 'Hebrew (Israel)',
    },
    {
      id: 'ar',
      name: 'Arabic',
    },
    {
      id: 'ar-DZ',
      name: 'Arabic (Algeria)',
    },
    {
      id: 'ar-KW',
      name: 'Arabic (Kuwait)',
    },
    {
      id: 'ar-MA',
      name: 'Arabic (Morocco)',
    },
    {
      id: 'ar-SA',
      name: 'Arabic (Saudi Arabia)',
    },
    {
      id: 'ar-EG',
      name: 'Arabic (Egypt)',
    },
    {
      id: 'hi',
      name: 'Hindi',
    },
    {
      id: 'hi-IN',
      name: 'Hindi (India)',
    },
    {
      id: 'th',
      name: 'Thai',
    },
    {
      id: 'th-TH',
      name: 'Thai (Thailand)',
    },
    {
      id: 'zh',
      name: 'Chinese',
    },
    {
      id: 'zh-CN',
      name: 'Chinese (China)',
    },
    {
      id: 'zh-HK',
      name: 'Chinese (Hong Kong)',
    },
    {
      id: 'zh-TW',
      name: 'Chinese (Taiwan)',
    },
    {
      id: 'ja',
      name: 'Japanese',
    },
    {
      id: 'ja-JP',
      name: 'Japanese (Japan)',
    },
    {
      id: 'ko',
      name: 'Korean',
    },
    {
      id: 'ko-KR',
      name: 'Korean (South Korea)',
    },
    {
      id: 'km',
      name: 'Khmer',
    },
    {
      id: 'km-KH',
      name: 'Khmer (Cambodia)',
    },
  ],
  currencies: [
    {
      id: 'AFN',
      name: 'Afghan Afghani',
    },
    {
      id: 'ALL',
      name: 'Albanian Lek',
    },
    {
      id: 'DZD',
      name: 'Algerian Dinar',
    },
    {
      id: 'AOA',
      name: 'Angolan Kwanza',
    },
    {
      id: 'ARS',
      name: 'Argentine Peso',
    },
    {
      id: 'AMD',
      name: 'Armenian Dram',
    },
    {
      id: 'AWG',
      name: 'Aruban Florin',
    },
    {
      id: 'AUD',
      name: 'Australian Dollar',
    },
    {
      id: 'AZN',
      name: 'Azerbaijani Manat',
    },
    {
      id: 'AZM',
      name: 'Azerbaijani Manat (1993-2006)',
    },
    {
      id: 'BSD',
      name: 'Bahamian Dollar',
    },
    {
      id: 'BHD',
      name: 'Bahraini Dinar',
    },
    {
      id: 'BDT',
      name: 'Bangladeshi Taka',
    },
    {
      id: 'BBD',
      name: 'Barbadian Dollar',
    },
    {
      id: 'BYR',
      name: 'Belarusian Ruble',
    },
    {
      id: 'BZD',
      name: 'Belize Dollar',
    },
    {
      id: 'BMD',
      name: 'Bermudan Dollar',
    },
    {
      id: 'BTN',
      name: 'Bhutanese Ngultrum',
    },
    {
      id: 'BOB',
      name: 'Bolivian Boliviano',
    },
    {
      id: 'BAM',
      name: 'Bosnia-Herzegovina Convertible Mark',
    },
    {
      id: 'BWP',
      name: 'Botswanan Pula',
    },
    {
      id: 'BRL',
      name: 'Brazilian Real',
    },
    {
      id: 'GBP',
      name: 'British Pound Sterling',
    },
    {
      id: 'BND',
      name: 'Brunei Dollar',
    },
    {
      id: 'BGN',
      name: 'Bulgarian Lev',
    },
    {
      id: 'BUK',
      name: 'Burmese Kyat',
    },
    {
      id: 'BIF',
      name: 'Burundian Franc',
    },
    {
      id: 'XOF',
      name: 'CFA Franc BCEAO',
    },
    {
      id: 'XPF',
      name: 'CFP Franc',
    },
    {
      id: 'KHR',
      name: 'Cambodian Riel',
    },
    {
      id: 'CAD',
      name: 'Canadian Dollar',
    },
    {
      id: 'CVE',
      name: 'Cape Verdean Escudo',
    },
    {
      id: 'KYD',
      name: 'Cayman Islands Dollar',
    },
    {
      id: 'CLP',
      name: 'Chilean Peso',
    },
    {
      id: 'CNY',
      name: 'Chinese Yuan Renminbi',
    },
    {
      id: 'COP',
      name: 'Colombian Peso',
    },
    {
      id: 'KMF',
      name: 'Comorian Franc',
    },
    {
      id: 'CDF',
      name: 'Congolese Franc',
    },
    {
      id: 'CRC',
      name: 'Costa Rican Colón',
    },
    {
      id: 'HRK',
      name: 'Croatian Kuna',
    },
    {
      id: 'CUP',
      name: 'Cuban Peso',
    },
    {
      id: 'CZK',
      name: 'Czech Republic Koruna',
    },
    {
      id: 'DKK',
      name: 'Danish Krone',
    },
    {
      id: 'DJF',
      name: 'Djiboutian Franc',
    },
    {
      id: 'DOP',
      name: 'Dominican Peso',
    },
    {
      id: 'XCD',
      name: 'East Caribbean Dollar',
    },
    {
      id: 'EGP',
      name: 'Egyptian Pound',
    },
    {
      id: 'GQE',
      name: 'Equatorial Guinean Ekwele',
    },
    {
      id: 'ERN',
      name: 'Eritrean Nakfa',
    },
    {
      id: 'EEK',
      name: 'Estonian Kroon',
    },
    {
      id: 'ETB',
      name: 'Ethiopian Birr',
    },
    {
      id: 'EUR',
      name: 'Euro',
    },
    {
      id: 'FKP',
      name: 'Falkland Islands Pound',
    },
    {
      id: 'FJD',
      name: 'Fijian Dollar',
    },
    {
      id: 'GMD',
      name: 'Gambian Dalasi',
    },
    {
      id: 'GEK',
      name: 'Georgian Kupon Larit',
    },
    {
      id: 'GEL',
      name: 'Georgian Lari',
    },
    {
      id: 'GHS',
      name: 'Ghanaian Cedi',
    },
    {
      id: 'GIP',
      name: 'Gibraltar Pound',
    },
    {
      id: 'GTQ',
      name: 'Guatemalan Quetzal',
    },
    {
      id: 'GNF',
      name: 'Guinean Franc',
    },
    {
      id: 'GYD',
      name: 'Guyanaese Dollar',
    },
    {
      id: 'HTG',
      name: 'Haitian Gourde',
    },
    {
      id: 'HNL',
      name: 'Honduran Lempira',
    },
    {
      id: 'HKD',
      name: 'Hong Kong Dollar',
    },
    {
      id: 'HUF',
      name: 'Hungarian Forint',
    },
    {
      id: 'ISK',
      name: 'Icelandic Króna',
    },
    {
      id: 'INR',
      name: 'Indian Rupee',
    },
    {
      id: 'IDR',
      name: 'Indonesian Rupiah',
    },
    {
      id: 'IRR',
      name: 'Iranian Rial',
    },
    {
      id: 'IQD',
      name: 'Iraqi Dinar',
    },
    {
      id: 'ILS',
      name: 'Israeli New Sheqel',
    },
    {
      id: 'JMD',
      name: 'Jamaican Dollar',
    },
    {
      id: 'JPY',
      name: 'Japanese Yen',
    },
    {
      id: 'JOD',
      name: 'Jordanian Dinar',
    },
    {
      id: 'KZT',
      name: 'Kazakhstan Tenge',
    },
    {
      id: 'KES',
      name: 'Kenyan Shilling',
    },
    {
      id: 'KWD',
      name: 'Kuwaiti Dinar',
    },
    {
      id: 'KGS',
      name: 'Kyrgystani Som',
    },
    {
      id: 'LAK',
      name: 'Laotian Kip',
    },
    {
      id: 'LVL',
      name: 'Latvian Lats',
    },
    {
      id: 'LBP',
      name: 'Lebanese Pound',
    },
    {
      id: 'LSL',
      name: 'Lesotho Loti',
    },
    {
      id: 'LRD',
      name: 'Liberian Dollar',
    },
    {
      id: 'LYD',
      name: 'Libyan Dinar',
    },
    {
      id: 'LTL',
      name: 'Lithuanian Litas',
    },
    {
      id: 'MOP',
      name: 'Macanese Pataca',
    },
    {
      id: 'MKD',
      name: 'Macedonian Denar',
    },
    {
      id: 'MGA',
      name: 'Malagasy Ariary',
    },
    {
      id: 'MWK',
      name: 'Malawian Kwacha',
    },
    {
      id: 'MYR',
      name: 'Malaysian Ringgit',
    },
    {
      id: 'MVR',
      name: 'Maldivian Rufiyaa',
    },
    {
      id: 'MRO',
      name: 'Mauritanian Ouguiya',
    },
    {
      id: 'MUR',
      name: 'Mauritian Rupee',
    },
    {
      id: 'MXN',
      name: 'Mexican Peso',
    },
    {
      id: 'MDL',
      name: 'Moldovan Leu',
    },
    {
      id: 'MNT',
      name: 'Mongolian Tugrik',
    },
    {
      id: 'MAD',
      name: 'Moroccan Dirham',
    },
    {
      id: 'MZN',
      name: 'Mozambican Metical',
    },
    {
      id: 'MMK',
      name: 'Myanma Kyat',
    },
    {
      id: 'NAD',
      name: 'Namibian Dollar',
    },
    {
      id: 'NPR',
      name: 'Nepalese Rupee',
    },
    {
      id: 'ANG',
      name: 'Netherlands Antillean Guilder',
    },
    {
      id: 'TWD',
      name: 'New Taiwan Dollar',
    },
    {
      id: 'NZD',
      name: 'New Zealand Dollar',
    },
    {
      id: 'NIC',
      name: 'Nicaraguan Cordoba',
    },
    {
      id: 'NGN',
      name: 'Nigerian Naira',
    },
    {
      id: 'KPW',
      name: 'North Korean Won',
    },
    {
      id: 'NOK',
      name: 'Norwegian Krone',
    },
    {
      id: 'ROL',
      name: 'Old Romanian Leu',
    },
    {
      id: 'TRL',
      name: 'Old Turkish Lira',
    },
    {
      id: 'OMR',
      name: 'Omani Rial',
    },
    {
      id: 'PKR',
      name: 'Pakistani Rupee',
    },
    {
      id: 'PAB',
      name: 'Panamanian Balboa',
    },
    {
      id: 'PGK',
      name: 'Papua New Guinean Kina',
    },
    {
      id: 'PYG',
      name: 'Paraguayan Guarani',
    },
    {
      id: 'PEN',
      name: 'Peruvian Nuevo Sol',
    },
    {
      id: 'PHP',
      name: 'Philippine Peso',
    },
    {
      id: 'PLN',
      name: 'Polish Zloty',
    },
    {
      id: 'QAR',
      name: 'Qatari Rial',
    },
    {
      id: 'RHD',
      name: 'Rhodesian Dollar',
    },
    {
      id: 'RON',
      name: 'Romanian Leu',
    },
    {
      id: 'RUB',
      name: 'Russian Ruble',
    },
    {
      id: 'RWF',
      name: 'Rwandan Franc',
    },
    {
      id: 'SHP',
      name: 'Saint Helena Pound',
    },
    {
      id: 'SVC',
      name: 'Salvadoran Colón',
    },
    {
      id: 'WST',
      name: 'Samoan Tala',
    },
    {
      id: 'SAR',
      name: 'Saudi Riyal',
    },
    {
      id: 'RSD',
      name: 'Serbian Dinar',
    },
    {
      id: 'SCR',
      name: 'Seychellois Rupee',
    },
    {
      id: 'SLL',
      name: 'Sierra Leonean Leone',
    },
    {
      id: 'SGD',
      name: 'Singapore Dollar',
    },
    {
      id: 'SKK',
      name: 'Slovak Koruna',
    },
    {
      id: 'SBD',
      name: 'Solomon Islands Dollar',
    },
    {
      id: 'SOS',
      name: 'Somali Shilling',
    },
    {
      id: 'ZAR',
      name: 'South African Rand',
    },
    {
      id: 'KRW',
      name: 'South Korean Won',
    },
    {
      id: 'LKR',
      name: 'Sri Lanka Rupee',
    },
    {
      id: 'SDG',
      name: 'Sudanese Pound',
    },
    {
      id: 'SRD',
      name: 'Surinamese Dollar',
    },
    {
      id: 'SZL',
      name: 'Swazi Lilangeni',
    },
    {
      id: 'SEK',
      name: 'Swedish Krona',
    },
    {
      id: 'CHF',
      name: 'Swiss Franc',
    },
    {
      id: 'SYP',
      name: 'Syrian Pound',
    },
    {
      id: 'STD',
      name: 'São Tomé and Príncipe Dobra',
    },
    {
      id: 'TJS',
      name: 'Tajikistani Somoni',
    },
    {
      id: 'TZS',
      name: 'Tanzanian Shilling',
    },
    {
      id: 'THB',
      name: 'Thai Baht',
    },
    {
      id: 'TOP',
      name: 'Tongan Paʻanga',
    },
    {
      id: 'TTD',
      name: 'Trinidad and Tobago Dollar',
    },
    {
      id: 'TND',
      name: 'Tunisian Dinar',
    },
    {
      id: 'TRY',
      name: 'Turkish Lira',
    },
    {
      id: 'TMM',
      name: 'Turkmenistani Manat',
    },
    {
      id: 'USD',
      name: 'US Dollar',
    },
    {
      id: 'UGX',
      name: 'Ugandan Shilling',
    },
    {
      id: 'UAH',
      name: 'Ukrainian Hryvnia',
    },
    {
      id: 'AED',
      name: 'United Arab Emirates Dirham',
    },
    {
      id: 'UYU',
      name: 'Uruguayan Peso',
    },
    {
      id: 'UZS',
      name: 'Uzbekistan Som',
    },
    {
      id: 'VUV',
      name: 'Vanuatu Vatu',
    },
    {
      id: 'VEB',
      name: 'Venezuelan Bolívar',
    },
    {
      id: 'VEF',
      name: 'Venezuelan Bolívar Fuerte',
    },
    {
      id: 'VND',
      name: 'Vietnamese Dong',
    },
    {
      id: 'CHE',
      name: 'WIR Euro',
    },
    {
      id: 'CHW',
      name: 'WIR Franc',
    },
    {
      id: 'YER',
      name: 'Yemeni Rial',
    },
    {
      id: 'ZMK',
      name: 'Zambian Kwacha',
    },
    {
      id: 'ZWD',
      name: 'Zimbabwean Dollar',
    },
  ],
  id: 'geo',
};

export const LANG_TO_COUNTRY_CODES: Record<string, string | undefined> = {
  aa: 'ET',
  ab: 'GE',
  abr: 'GH',
  ace: 'ID',
  ach: 'UG',
  ada: 'GH',
  ady: 'RU',
  ae: 'IR',
  aeb: 'TN',
  af: 'ZA',
  agq: 'CM',
  aho: 'IN',
  ak: 'GH',
  akk: 'IQ',
  aln: 'XK',
  alt: 'RU',
  am: 'ET',
  amo: 'NG',
  aoz: 'ID',
  apd: 'TG',
  ar: 'EG',
  arc: 'IR',
  'arc-Nbat': 'JO',
  'arc-Palm': 'SY',
  arn: 'CL',
  aro: 'BO',
  arq: 'DZ',
  ary: 'MA',
  arz: 'EG',
  as: 'IN',
  asa: 'TZ',
  ase: 'US',
  ast: 'ES',
  atj: 'CA',
  av: 'RU',
  awa: 'IN',
  ay: 'BO',
  az: 'AZ',
  'az-Arab': 'IR',
  ba: 'RU',
  bal: 'PK',
  ban: 'ID',
  bap: 'NP',
  bar: 'AT',
  bas: 'CM',
  bax: 'CM',
  bbc: 'ID',
  bbj: 'CM',
  bci: 'CI',
  be: 'BY',
  bej: 'SD',
  bem: 'ZM',
  bew: 'ID',
  bez: 'TZ',
  bfd: 'CM',
  bfq: 'IN',
  bft: 'PK',
  bfy: 'IN',
  bg: 'BG',
  bgc: 'IN',
  bgn: 'PK',
  bgx: 'TR',
  bhb: 'IN',
  bhi: 'IN',
  bhk: 'PH',
  bho: 'IN',
  bi: 'VU',
  bik: 'PH',
  bin: 'NG',
  bjj: 'IN',
  bjn: 'ID',
  bjt: 'SN',
  bkm: 'CM',
  bku: 'PH',
  blt: 'VN',
  bm: 'ML',
  bmq: 'ML',
  bn: 'BD',
  bo: 'CN',
  bpy: 'IN',
  bqi: 'IR',
  bqv: 'CI',
  br: 'FR',
  bra: 'IN',
  brh: 'PK',
  brx: 'IN',
  bs: 'BA',
  bsq: 'LR',
  bss: 'CM',
  bto: 'PH',
  btv: 'PK',
  bua: 'RU',
  buc: 'YT',
  bug: 'ID',
  bum: 'CM',
  bvb: 'GQ',
  byn: 'ER',
  byv: 'CM',
  bze: 'ML',
  ca: 'ES',
  cch: 'NG',
  ccp: 'BD',
  ce: 'RU',
  ceb: 'PH',
  cgg: 'UG',
  ch: 'GU',
  chk: 'FM',
  chm: 'RU',
  cho: 'US',
  chp: 'CA',
  chr: 'US',
  cja: 'KH',
  cjm: 'VN',
  ckb: 'IQ',
  co: 'FR',
  cop: 'EG',
  cps: 'PH',
  cr: 'CA',
  crh: 'UA',
  crj: 'CA',
  crk: 'CA',
  crl: 'CA',
  crm: 'CA',
  crs: 'SC',
  cs: 'CZ',
  csb: 'PL',
  csw: 'CA',
  ctd: 'MM',
  cu: 'RU',
  'cu-Glag': 'BG',
  cv: 'RU',
  cy: 'GB',
  da: 'DK',
  dak: 'US',
  dar: 'RU',
  dav: 'KE',
  dcc: 'IN',
  de: 'DE',
  den: 'CA',
  dgr: 'CA',
  dje: 'NE',
  dnj: 'CI',
  doi: 'IN',
  dsb: 'DE',
  dtm: 'ML',
  dtp: 'MY',
  dty: 'NP',
  dua: 'CM',
  dv: 'MV',
  dyo: 'SN',
  dyu: 'BF',
  dz: 'BT',
  ebu: 'KE',
  ee: 'GH',
  efi: 'NG',
  egl: 'IT',
  egy: 'EG',
  eky: 'MM',
  el: 'GR',
  en: 'US',
  'en-Shaw': 'GB',
  es: 'ES',
  esu: 'US',
  et: 'EE',
  ett: 'IT',
  eu: 'ES',
  ewo: 'CM',
  ext: 'ES',
  fa: 'IR',
  fan: 'GQ',
  ff: 'SN',
  'ff-Adlm': 'GN',
  ffm: 'ML',
  fi: 'FI',
  fia: 'SD',
  fil: 'PH',
  fit: 'SE',
  fj: 'FJ',
  fo: 'FO',
  fon: 'BJ',
  fr: 'FR',
  frc: 'US',
  frp: 'FR',
  frr: 'DE',
  frs: 'DE',
  fub: 'CM',
  fud: 'WF',
  fuf: 'GN',
  fuq: 'NE',
  fur: 'IT',
  fuv: 'NG',
  fvr: 'SD',
  fy: 'NL',
  ga: 'IE',
  gaa: 'GH',
  gag: 'MD',
  gan: 'CN',
  gay: 'ID',
  gbm: 'IN',
  gbz: 'IR',
  gcr: 'GF',
  gd: 'GB',
  gez: 'ET',
  ggn: 'NP',
  gil: 'KI',
  gjk: 'PK',
  gju: 'PK',
  gl: 'ES',
  glk: 'IR',
  gn: 'PY',
  gom: 'IN',
  gon: 'IN',
  gor: 'ID',
  gos: 'NL',
  got: 'UA',
  grc: 'CY',
  'grc-Linb': 'GR',
  grt: 'IN',
  gsw: 'CH',
  gu: 'IN',
  gub: 'BR',
  guc: 'CO',
  gur: 'GH',
  guz: 'KE',
  gv: 'IM',
  gvr: 'NP',
  gwi: 'CA',
  ha: 'NG',
  hak: 'CN',
  haw: 'US',
  haz: 'AF',
  he: 'IL',
  hi: 'IN',
  hif: 'FJ',
  hil: 'PH',
  hlu: 'TR',
  hmd: 'CN',
  hnd: 'PK',
  hne: 'IN',
  hnj: 'LA',
  hnn: 'PH',
  hno: 'PK',
  ho: 'PG',
  hoc: 'IN',
  hoj: 'IN',
  hr: 'HR',
  hsb: 'DE',
  hsn: 'CN',
  ht: 'HT',
  hu: 'HU',
  hy: 'AM',
  hz: 'NA',
  ia: 'FR',
  iba: 'MY',
  ibb: 'NG',
  id: 'ID',
  ife: 'TG',
  ig: 'NG',
  ii: 'CN',
  ik: 'US',
  ikt: 'CA',
  ilo: 'PH',
  in: 'ID',
  inh: 'RU',
  is: 'IS',
  it: 'IT',
  iu: 'CA',
  iw: 'IL',
  izh: 'RU',
  ja: 'JP',
  jam: 'JM',
  jgo: 'CM',
  ji: 'UA',
  jmc: 'TZ',
  jml: 'NP',
  jut: 'DK',
  jv: 'ID',
  jw: 'ID',
  ka: 'GE',
  kaa: 'UZ',
  kab: 'DZ',
  kac: 'MM',
  kaj: 'NG',
  kam: 'KE',
  kao: 'ML',
  kbd: 'RU',
  kby: 'NE',
  kcg: 'NG',
  kck: 'ZW',
  kde: 'TZ',
  kdh: 'TG',
  kdt: 'TH',
  kea: 'CV',
  ken: 'CM',
  kfo: 'CI',
  kfr: 'IN',
  kfy: 'IN',
  kg: 'CD',
  kge: 'ID',
  kgp: 'BR',
  kha: 'IN',
  khb: 'CN',
  khn: 'IN',
  khq: 'ML',
  kht: 'IN',
  khw: 'PK',
  ki: 'KE',
  kiu: 'TR',
  kj: 'NA',
  kjg: 'LA',
  kk: 'KZ',
  'kk-Arab': 'CN',
  kkj: 'CM',
  kl: 'GL',
  kln: 'KE',
  km: 'KH',
  kmb: 'AO',
  kn: 'IN',
  knf: 'SN',
  ko: 'KR',
  koi: 'RU',
  kok: 'IN',
  kos: 'FM',
  kpe: 'LR',
  krc: 'RU',
  kri: 'SL',
  krj: 'PH',
  krl: 'RU',
  kru: 'IN',
  ks: 'IN',
  ksb: 'TZ',
  ksf: 'CM',
  ksh: 'DE',
  ku: 'TR',
  'ku-Arab': 'IQ',
  kum: 'RU',
  kv: 'RU',
  kvr: 'ID',
  kvx: 'PK',
  kw: 'GB',
  kxm: 'TH',
  kxp: 'PK',
  ky: 'KG',
  'ky-Arab': 'CN',
  'ky-Latn': 'TR',
  la: 'VA',
  lab: 'GR',
  lad: 'IL',
  lag: 'TZ',
  lah: 'PK',
  laj: 'UG',
  lb: 'LU',
  lbe: 'RU',
  lbw: 'ID',
  lcp: 'CN',
  lep: 'IN',
  lez: 'RU',
  lg: 'UG',
  li: 'NL',
  lif: 'NP',
  'lif-Limb': 'IN',
  lij: 'IT',
  lis: 'CN',
  ljp: 'ID',
  lki: 'IR',
  lkt: 'US',
  lmn: 'IN',
  lmo: 'IT',
  ln: 'CD',
  lo: 'LA',
  lol: 'CD',
  loz: 'ZM',
  lrc: 'IR',
  lt: 'LT',
  ltg: 'LV',
  lu: 'CD',
  lua: 'CD',
  luo: 'KE',
  luy: 'KE',
  luz: 'IR',
  lv: 'LV',
  lwl: 'TH',
  lzh: 'CN',
  lzz: 'TR',
  mad: 'ID',
  maf: 'CM',
  mag: 'IN',
  mai: 'IN',
  mak: 'ID',
  man: 'GM',
  'man-Nkoo': 'GN',
  mas: 'KE',
  maz: 'MX',
  mdf: 'RU',
  mdh: 'PH',
  mdr: 'ID',
  men: 'SL',
  mer: 'KE',
  mfa: 'TH',
  mfe: 'MU',
  mg: 'MG',
  mgh: 'MZ',
  mgo: 'CM',
  mgp: 'NP',
  mgy: 'TZ',
  mh: 'MH',
  mi: 'NZ',
  min: 'ID',
  mis: 'IQ',
  mk: 'MK',
  ml: 'IN',
  mls: 'SD',
  mn: 'MN',
  'mn-Mong': 'CN',
  mni: 'IN',
  mnw: 'MM',
  moe: 'CA',
  moh: 'CA',
  mos: 'BF',
  mr: 'IN',
  mrd: 'NP',
  mrj: 'RU',
  mro: 'BD',
  ms: 'MY',
  mt: 'MT',
  mtr: 'IN',
  mua: 'CM',
  mus: 'US',
  mvy: 'PK',
  mwk: 'ML',
  mwr: 'IN',
  mwv: 'ID',
  mxc: 'ZW',
  my: 'MM',
  myv: 'RU',
  myx: 'UG',
  myz: 'IR',
  mzn: 'IR',
  na: 'NR',
  nan: 'CN',
  nap: 'IT',
  naq: 'NA',
  nb: 'NO',
  nch: 'MX',
  nd: 'ZW',
  ndc: 'MZ',
  nds: 'DE',
  ne: 'NP',
  new: 'NP',
  ng: 'NA',
  ngl: 'MZ',
  nhe: 'MX',
  nhw: 'MX',
  nij: 'ID',
  niu: 'NU',
  njo: 'IN',
  nl: 'NL',
  nmg: 'CM',
  nn: 'NO',
  nnh: 'CM',
  no: 'NO',
  nod: 'TH',
  noe: 'IN',
  non: 'SE',
  nqo: 'GN',
  nr: 'ZA',
  nsk: 'CA',
  nso: 'ZA',
  nus: 'SS',
  nv: 'US',
  nxq: 'CN',
  ny: 'MW',
  nym: 'TZ',
  nyn: 'UG',
  nzi: 'GH',
  oc: 'FR',
  om: 'ET',
  or: 'IN',
  os: 'GE',
  osa: 'US',
  otk: 'MN',
  pa: 'IN',
  'pa-Arab': 'PK',
  pag: 'PH',
  pal: 'IR',
  'pal-Phlp': 'CN',
  pam: 'PH',
  pap: 'AW',
  pau: 'PW',
  pcd: 'FR',
  pcm: 'NG',
  pdc: 'US',
  pdt: 'CA',
  peo: 'IR',
  pfl: 'DE',
  phn: 'LB',
  pka: 'IN',
  pko: 'KE',
  pl: 'PL',
  pms: 'IT',
  pnt: 'GR',
  pon: 'FM',
  pra: 'PK',
  prd: 'IR',
  ps: 'AF',
  pt: 'BR',
  puu: 'GA',
  qu: 'PE',
  quc: 'GT',
  qug: 'EC',
  raj: 'IN',
  rcf: 'RE',
  rej: 'ID',
  rgn: 'IT',
  ria: 'IN',
  rif: 'MA',
  rjs: 'NP',
  rkt: 'BD',
  rm: 'CH',
  rmf: 'FI',
  rmo: 'CH',
  rmt: 'IR',
  rmu: 'SE',
  rn: 'BI',
  rng: 'MZ',
  ro: 'RO',
  rob: 'ID',
  rof: 'TZ',
  rtm: 'FJ',
  ru: 'RU',
  rue: 'UA',
  rug: 'SB',
  rw: 'RW',
  rwk: 'TZ',
  ryu: 'JP',
  sa: 'IN',
  saf: 'GH',
  sah: 'RU',
  saq: 'KE',
  sas: 'ID',
  sat: 'IN',
  sav: 'SN',
  saz: 'IN',
  sbp: 'TZ',
  sc: 'IT',
  sck: 'IN',
  scn: 'IT',
  sco: 'GB',
  scs: 'CA',
  sd: 'PK',
  'sd-Deva': 'IN',
  'sd-Khoj': 'IN',
  'sd-Sind': 'IN',
  sdc: 'IT',
  sdh: 'IR',
  se: 'NO',
  sef: 'CI',
  seh: 'MZ',
  sei: 'MX',
  ses: 'ML',
  sg: 'CF',
  sga: 'IE',
  sgs: 'LT',
  shi: 'MA',
  shn: 'MM',
  si: 'LK',
  sid: 'ET',
  sk: 'SK',
  skr: 'PK',
  sl: 'SI',
  sli: 'PL',
  sly: 'ID',
  sm: 'WS',
  sma: 'SE',
  smj: 'SE',
  smn: 'FI',
  smp: 'IL',
  sms: 'FI',
  sn: 'ZW',
  snk: 'ML',
  so: 'SO',
  sou: 'TH',
  sq: 'AL',
  sr: 'RS',
  srb: 'IN',
  srn: 'SR',
  srr: 'SN',
  srx: 'IN',
  ss: 'ZA',
  ssy: 'ER',
  st: 'ZA',
  stq: 'DE',
  su: 'ID',
  suk: 'TZ',
  sus: 'GN',
  sv: 'SE',
  sw: 'TZ',
  swb: 'YT',
  swc: 'CD',
  swg: 'DE',
  swv: 'IN',
  sxn: 'ID',
  syl: 'BD',
  syr: 'IQ',
  szl: 'PL',
  ta: 'IN',
  taj: 'NP',
  tbw: 'PH',
  tcy: 'IN',
  tdd: 'CN',
  tdg: 'NP',
  tdh: 'NP',
  te: 'IN',
  tem: 'SL',
  teo: 'UG',
  tet: 'TL',
  tg: 'TJ',
  'tg-Arab': 'PK',
  th: 'TH',
  thl: 'NP',
  thq: 'NP',
  thr: 'NP',
  ti: 'ET',
  tig: 'ER',
  tiv: 'NG',
  tk: 'TM',
  tkl: 'TK',
  tkr: 'AZ',
  tkt: 'NP',
  tl: 'PH',
  tly: 'AZ',
  tmh: 'NE',
  tn: 'ZA',
  to: 'TO',
  tog: 'MW',
  tpi: 'PG',
  tr: 'TR',
  tru: 'TR',
  trv: 'TW',
  ts: 'ZA',
  tsd: 'GR',
  tsf: 'NP',
  tsg: 'PH',
  tsj: 'BT',
  tt: 'RU',
  ttj: 'UG',
  tts: 'TH',
  ttt: 'AZ',
  tum: 'MW',
  tvl: 'TV',
  twq: 'NE',
  txg: 'CN',
  ty: 'PF',
  tyv: 'RU',
  tzm: 'MA',
  udm: 'RU',
  ug: 'CN',
  'ug-Cyrl': 'KZ',
  uga: 'SY',
  uk: 'UA',
  uli: 'FM',
  umb: 'AO',
  und: 'US',
  unr: 'IN',
  'unr-Deva': 'NP',
  unx: 'IN',
  ur: 'PK',
  uz: 'UZ',
  'uz-Arab': 'AF',
  vai: 'LR',
  ve: 'ZA',
  vec: 'IT',
  vep: 'RU',
  vi: 'VN',
  vic: 'SX',
  vls: 'BE',
  vmf: 'DE',
  vmw: 'MZ',
  vot: 'RU',
  vro: 'EE',
  vun: 'TZ',
  wa: 'BE',
  wae: 'CH',
  wal: 'ET',
  war: 'PH',
  wbp: 'AU',
  wbq: 'IN',
  wbr: 'IN',
  wls: 'WF',
  wni: 'KM',
  wo: 'SN',
  wtm: 'IN',
  wuu: 'CN',
  xav: 'BR',
  xcr: 'TR',
  xh: 'ZA',
  xlc: 'TR',
  xld: 'TR',
  xmf: 'GE',
  xmn: 'CN',
  xmr: 'SD',
  xna: 'SA',
  xnr: 'IN',
  xog: 'UG',
  xpr: 'IR',
  xsa: 'YE',
  xsr: 'NP',
  yao: 'MZ',
  yap: 'FM',
  yav: 'CM',
  ybb: 'CM',
  yo: 'NG',
  yrl: 'BR',
  yua: 'MX',
  yue: 'HK',
  'yue-Hans': 'CN',
  za: 'CN',
  zag: 'SD',
  zdj: 'KM',
  zea: 'NL',
  zgh: 'MA',
  zh: 'CN',
  'zh-Bopo': 'TW',
  'zh-Hanb': 'TW',
  'zh-Hant': 'TW',
  zlm: 'TG',
  zmi: 'MY',
  zu: 'ZA',
  zza: 'TR',
};

export const CURRENCY_COUNTRIES = Object.freeze({
  USD: { name: 'United States', iso: 'US' },
  EUR: { name: 'Europe', iso: 'EU' },
  GBP: { name: 'United Kingdom', iso: 'UK' },
  JPY: { name: 'Japan', iso: 'JP' },
  CAD: { name: 'Canada', iso: 'CA' },
  AUD: { name: 'Australia', iso: 'AU' },
  CHF: { name: 'Switzerland', iso: 'CH' },
  CNY: { name: 'China', iso: 'CN' },
  SEK: { name: 'Sweden', iso: 'SE' },
  NZD: { name: 'New Zealand', iso: 'NZ' },
  NOK: { name: 'Norway', iso: 'NO' },
  MXN: { name: 'Mexico', iso: 'MX' },
  SGD: { name: 'Singapore', iso: 'SG' },
  HKD: { name: 'Hong Kong', iso: 'HK' },
  KRW: { name: 'South Korea', iso: 'KR' },
  INR: { name: 'India', iso: 'IN' },
  BRL: { name: 'Brazil', iso: 'BR' },
  RUB: { name: 'Russia', iso: 'RU' },
  ZAR: { name: 'South Africa', iso: 'ZA' },
  TRY: { name: 'Turkey', iso: 'TR' },
  AED: { name: 'United Arab Emirates', iso: 'AE' },
  THB: { name: 'Thailand', iso: 'TH' },
  IDR: { name: 'Indonesia', iso: 'ID' },
  SAR: { name: 'Saudi Arabia', iso: 'SA' },
  PLN: { name: 'Poland', iso: 'PL' },
  PHP: { name: 'Philippines', iso: 'PH' },
  ILS: { name: 'Israel', iso: 'IL' },
  MYR: { name: 'Malaysia', iso: 'MY' },
  CZK: { name: 'Czech Republic', iso: 'CZ' },
  HUF: { name: 'Hungary', iso: 'HU' },
  CLP: { name: 'Chile', iso: 'CL' },
  DKK: { name: 'Denmark', iso: 'DK' },
  RON: { name: 'Romania', iso: 'RO' },
  ARS: { name: 'Argentina', iso: 'AR' },
  COP: { name: 'Colombia', iso: 'CO' },
  TWD: { name: 'Taiwan', iso: 'TW' },
  BGN: { name: 'Bulgaria', iso: 'BG' },
  EGP: { name: 'Egypt', iso: 'EG' },
  PKR: { name: 'Pakistan', iso: 'PK' },
  NGN: { name: 'Nigeria', iso: 'NG' },
  VND: { name: 'Vietnam', iso: 'VN' },
  IQD: { name: 'Iraq', iso: 'IQ' },
  MAD: { name: 'Morocco', iso: 'MA' },
  KES: { name: 'Kenya', iso: 'KE' },
  DZD: { name: 'Algeria', iso: 'DZ' },
  UAH: { name: 'Ukraine', iso: 'UA' },
  XAF: { name: 'Cameroon', iso: 'CM' },
  XOF: { name: "Côte d'Ivoire", iso: 'CI' },
  GHS: { name: 'Ghana', iso: 'GH' },
  BYN: { name: 'Belarus', iso: 'BY' },
  LKR: { name: 'Sri Lanka', iso: 'LK' },
  SDG: { name: 'Sudan', iso: 'SD' },
  AFN: { name: 'Afghanistan', iso: 'AF' },
  ALL: { name: 'Albania', iso: 'AL' },
  AMD: { name: 'Armenia', iso: 'AM' },
  AOA: { name: 'Angola', iso: 'AO' },
  AWG: { name: 'Aruba', iso: 'AW' },
  AZN: { name: 'Azerbaijan', iso: 'AZ' },
  BAM: { name: 'Bosnia and Herzegovina', iso: 'BA' },
  BBD: { name: 'Barbados', iso: 'BB' },
  BDT: { name: 'Bangladesh', iso: 'BD' },
  BHD: { name: 'Bahrain', iso: 'BH' },
  BIF: { name: 'Burundi', iso: 'BI' },
  BMD: { name: 'Bermuda', iso: 'BM' },
  BND: { name: 'Brunei', iso: 'BN' },
  BOB: { name: 'Bolivia', iso: 'BO' },
  BSD: { name: 'Bahamas', iso: 'BS' },
  BTN: { name: 'Bhutan', iso: 'BT' },
  BWP: { name: 'Botswana', iso: 'BW' },
  BZD: { name: 'Belize', iso: 'BZ' },
  CDF: { name: 'Democratic Republic of the Congo', iso: 'CD' },
  CLF: { name: 'Chile (Unidad de Fomento)', iso: 'CL' },
  CRC: { name: 'Costa Rica', iso: 'CR' },
  CVE: { name: 'Cape Verde', iso: 'CV' },
  DJF: { name: 'Djibouti', iso: 'DJ' },
  DOP: { name: 'Dominican Republic', iso: 'DO' },
  ERN: { name: 'Eritrea', iso: 'ER' },
  ETB: { name: 'Ethiopia', iso: 'ET' },
  FKP: { name: 'Falkland Islands', iso: 'FK' },
  GEL: { name: 'Georgia', iso: 'GE' },
  GIP: { name: 'Gibraltar', iso: 'GI' },
  GMD: { name: 'Gambia', iso: 'GM' },
  GNF: { name: 'Guinea', iso: 'GN' },
  GTQ: { name: 'Guatemala', iso: 'GT' },
  GYD: { name: 'Guyana', iso: 'GY' },
  HNL: { name: 'Honduras', iso: 'HN' },
  HRK: { name: 'Croatia', iso: 'HR' },
  HTG: { name: 'Haiti', iso: 'HT' },
  IRR: { name: 'Iran', iso: 'IR' },
  ISK: { name: 'Iceland', iso: 'IS' },
  JMD: { name: 'Jamaica', iso: 'JM' },
  JOD: { name: 'Jordan', iso: 'JO' },
  KGS: { name: 'Kyrgyzstan', iso: 'KG' },
  KHR: { name: 'Cambodia', iso: 'KH' },
  KMF: { name: 'Comoros', iso: 'KM' },
  KPW: { name: 'North Korea', iso: 'KP' },
  KWD: { name: 'Kuwait', iso: 'KW' },
  KYD: { name: 'Cayman Islands', iso: 'KY' },
  KZT: { name: 'Kazakhstan', iso: 'KZ' },
  LAK: { name: 'Laos', iso: 'LA' },
  LBP: { name: 'Lebanon', iso: 'LB' },
  LRD: { name: 'Liberia', iso: 'LR' },
  LSL: { name: 'Lesotho', iso: 'LS' },
  LYD: { name: 'Libya', iso: 'LY' },
  MDL: { name: 'Moldova', iso: 'MD' },
  MGA: { name: 'Madagascar', iso: 'MG' },
  MKD: { name: 'North Macedonia', iso: 'MK' },
  MMK: { name: 'Myanmar', iso: 'MM' },
  MNT: { name: 'Mongolia', iso: 'MN' },
  MOP: { name: 'Macau', iso: 'MO' },
  MRO: { name: 'Mauritania', iso: 'MR' },
  MUR: { name: 'Mauritius', iso: 'MU' },
  MVR: { name: 'Maldives', iso: 'MV' },
  MWK: { name: 'Malawi', iso: 'MW' },
  NAD: { name: 'Namibia', iso: 'NA' },
  NPR: { name: 'Nepal', iso: 'NP' },
  OMR: { name: 'Oman', iso: 'OM' },
  PAB: { name: 'Panama', iso: 'PA' },
  PEN: { name: 'Peru', iso: 'PE' },
  PGK: { name: 'Papua New Guinea', iso: 'PG' },
  PYG: { name: 'Paraguay', iso: 'PY' },
  QAR: { name: 'Qatar', iso: 'QA' },
  RSD: { name: 'Serbia', iso: 'RS' },
  RWF: { name: 'Rwanda', iso: 'RW' },
  SBD: { name: 'Solomon Islands', iso: 'SB' },
  SCR: { name: 'Seychelles', iso: 'SC' },
  SHP: { name: 'Saint Helena', iso: 'SH-HL' },
  SLL: { name: 'Sierra Leone', iso: 'SL' },
  SOS: { name: 'Somalia', iso: 'SO' },
  SRD: { name: 'Suriname', iso: 'SR' },
  STD: { name: 'São Tomé and Príncipe', iso: 'ST' },
  SZL: { name: 'Eswatini', iso: 'SZ' },
  TJS: { name: 'Tajikistan', iso: 'TJ' },
  TMT: { name: 'Turkmenistan', iso: 'TM' },
  TND: { name: 'Tunisia', iso: 'TN' },
  TOP: { name: 'Tonga', iso: 'TO' },
  TTD: { name: 'Trinidad and Tobago', iso: 'TT' },
  TZS: { name: 'Tanzania', iso: 'TZ' },
  UGX: { name: 'Uganda', iso: 'UG' },
  UYU: { name: 'Uruguay', iso: 'UY' },
  UZS: { name: 'Uzbekistan', iso: 'UZ' },
  VEF: { name: 'Venezuela', iso: 'VE' },
  VUV: { name: 'Vanuatu', iso: 'VU' },
  WST: { name: 'Samoa', iso: 'WS' },
  XCD: { name: 'Eastern Caribbean', iso: 'AG' },
  YER: { name: 'Yemen', iso: 'YE' },
  ZMW: { name: 'Zambia', iso: 'ZM' },
  ZWG: { name: 'Zimbabwe', iso: 'ZW' },
});
